const ymmJSSelectors = {};
class ymmJS extends HTMLElement {
    constructor() {
        super();
        this.initJsonData();
    }

    async initJsonData(){
        let json = await vehicleUtility.tsvVehicleJSON();
        
        this.initVehicle(json);
    }

    initVehicle(json){
        this.vehicleJsonData = json;
        this.defaultMaterial = window.globalVariables.default_material;

        this.selectedPartNumber = [];

        this.uniqueYears = [
            ...new Set(Object.values(this.vehicleJsonData).map((item) => item.year)),
        ];
        this.uniqueMake = [
            ...new Set(Object.values(this.vehicleJsonData).map((item) => item.make))
        ];
        this.uniqueModels = [
            ...new Set(Object.values(this.vehicleJsonData).map((item) => item.model)),
        ];
        this.uniqueTrims = [
            ...new Set(Object.values(this.vehicleJsonData).map((item) => item.trim)),
        ];
        this.uniqueCabTypes = [
            ...new Set(Object.values(this.vehicleJsonData).map((item) => item.cab_type)),
        ];
        this.uniqueRows = [
            ...new Set(Object.values(this.vehicleJsonData).map((item) => item.row))
        ];

        this.uniqueParts = [
            ...new Set(Object.values(this.vehicleJsonData).map((item) => item.part_number))
        ];
        
        this.yearSelect = this.querySelectorAll("[data-year-filter-select]");
    
        this.makeSelect = this.querySelector("[data-make-filter-select]");
        //this.makeSelectAll = document.querySelectorAll("[data-make-filter-select]");
      
        this.modelSelect = this.querySelector("[data-modal-filter-select]");
        //this.modelSelectAll = document.querySelectorAll("[data-modal-filter-select]");

        this.trimSelect = this.querySelector("[data-trim-filter-select]");
        //this.trimSelectAll = document.querySelectorAll("[data-trim-filter-select]");

        this.cabTypeSelect = this.querySelector("[data-cab-filter-select]");
        //this.cabTypeSelectAll = document.querySelector("[data-cab-filter-select]");
        this.rowSelect = document.querySelector("[data-row-filter-select]");

        this.partSelect = document.querySelector("[data-part-filter-select]");

        let yearHTML = '';

        if(this.closest("modal-dialog") != null){
            this.uniqueYears.sort().reverse().forEach((years) => {
                if( years != null){
                    yearHTML += `
                    <li class="for-check" data-value="${years}">
                        <input type="radio" class="ymm-input form-check-input d-none" data-label="${years}" value="${years}" id="year-${years}-${this.closest("modal-dialog").getAttribute("id")}" name="year-filter"/>
                        <label class="option_txt form-check-label text-capitalize" for="year-${years}-${this.closest("modal-dialog").getAttribute("id")}" title="Label for ${years}">${years}</label>
                    </li>
                    `;
                }
            });
        }else{
            this.uniqueYears.sort().reverse().forEach((years) => {
                if( years != null){
                    yearHTML += `
                    <li class="for-check" data-value="${years}">
                        <input type="radio" class="ymm-input form-check-input d-none" data-label="${years}" value="${years}" id="year-${years}" name="year-filter"/>
                        <label class="option_txt form-check-label text-capitalize" for="year-${years}" title="Label for ${years}">${years}</label>
                    </li>
                    `;
                }
            });
        }

     
        if(this.yearSelect != null){

            this.yearSelect.forEach(select => {
                select.innerHTML = yearHTML 

                this.yearOptions = select.querySelectorAll('li');
                this.yearOptions.forEach((option) => {
                    option.addEventListener('click', (event) => {
                        let _this = event.currentTarget;
                        this.yearOptions.forEach(option => option.classList.remove('selected'));
                        _this.classList.add('selected');
                        _this.closest('.custom-dropdown').querySelector('.year-default .option_txt').innerHTML = _this.querySelector('.option_txt').innerHTML;
                        //document.querySelector('.year-default .option_txt').innerHTML = _this.querySelector('.option_txt').innerHTML;
                        this.selectContainer = _this.closest('.custom--select');
                        Utility.toggleElement(this.selectContainer, 'close');
                    });
                }) 
            })
    
    
            // Add event listener to the year select element
            let yearInputs = this.querySelectorAll('[data-year-filter-select] input');
            // let yearInputs = this.yearSelect.querySelectorAll('input');
            yearInputs.forEach((yearInput) => {
                yearInput.addEventListener('change', (event) => {

                    let currentvalue = this.querySelector('[data-year-filter-select] [name="year-filter"]:checked').value;
                    let currentvalueLable = this.querySelector('[data-year-filter-select] [name="year-filter"]:checked').getAttribute('data-label');

                    let els = document.querySelectorAll('shop-vehicle');
                
                    els.forEach(el => {
                        el.querySelector('.make-default .option_txt').innerHTML = 'Make';
                        el.querySelector('.model-default .option_txt').innerHTML = 'Model';
                        el.querySelector('.trim-default .option_txt').innerHTML = 'Trim';
                        el.querySelector('.cab-default .option_txt').innerHTML = 'Cab Type';
                        el.querySelector('[data-trim-wrap] .custom-dropdown').classList.add('disabled')
                        el.querySelector('[data-cab-wrap] .custom-dropdown').classList.add('disabled')
                        el.querySelector('[data-model-wrap] .custom-dropdown').classList.add('disabled')
                        el.modelSelect.innerHTML = '';
                        el.trimSelect.innerHTML = '';
                        el.cabTypeSelect.innerHTML = '';
                        el._updateMakes(currentvalueLable);
                    });

                })
            });
             // Add a click event listener to the 'shopVehicleBtn'
            const shopVehicleBtn = this.querySelectorAll('[data-shop-vehicle-btn]');
            shopVehicleBtn.forEach((shopVehicleBtnInput) => {
                shopVehicleBtnInput.addEventListener('click', (event) => {
                    event.target.closest('.btn').classList.add('loading');
                    var isCustomer = document.body.classList.contains('customer-loggedin');
                    var isCustomerB2B = document.body.classList.contains('b2b-customer');
            
                    if(isCustomer && !isCustomerB2B){                        
                        this._addVehicle();
                    } else if(isCustomer && isCustomerB2B) {
                        this._searchVehicle();
                    } else {
                        this._addVehicle();
                    }
                });
            });
            const shopVehicleBtnNew = document.querySelector('[data-shop-vehicle-btn-new]');
            shopVehicleBtnNew.addEventListener('click', (event) => {
                // event.target.closest('.btn').classList.add('loading');
                // document.querySelector('[data-shop-vehicle-btn]').click();
                event.target.closest('.btn').classList.add('loading');
                var isCustomer = document.body.classList.contains('customer-loggedin');
                var isCustomerB2B = document.body.classList.contains('b2b-customer');
        
                if(isCustomer && !isCustomerB2B){                        
                    this._addVehicle();
                } else if(isCustomer && isCustomerB2B) {
                    this._searchVehicle();
                } else {
                    this._addVehicle();
                }
            });
            
        }
    
        vehicleUtility._deterMineVehicles();

        this.selectedYMMData = window.customerSelectedVehicles.vehicle
        this.selectedHeavyEqipData =  window.customerSelectedVehicles.heavyVehicle
        this.selectedSideYMMData = window.customerSelectedVehicles.sidebyside
        this.selectedTrufData = window.customerSelectedVehicles.turf
        this.selectedSahdtData = window.customerSelectedVehicles.sahdt

        //Store data in list
        vehicleUtility._listVehicle();
         if (document.body.classList.contains('template-account')) {
            vehicleUtility._listAccountVehicle();
        }
        this._listVehicleEvents();

        this.defaultVehicle = false;
        if(this.selectedHeavyEqipData.length > 0){
           this.selectedHeavyEqipData.forEach((selectedHQ) => {
               if(selectedHQ.default == true){
                   this.defaultVehicle = false;
               }
            })
        } else {
           // Determine if it's the default vehicle
           this.defaultVehicle = this.selectedYMMData.length === 0;
        }

        // PDP Change vehicle
        this.editPDPVehcileBtn = document.querySelector('[data-pdp-edit-vehcile]');
        if(this.editPDPVehcileBtn != undefined){
            this.editPDPVehcileBtn.addEventListener('click',(event) => {
                event.preventDefault();
                event.stopPropagation();
                document.querySelector('#change-pdp-vehicle').show();
                let currentData = JSON.parse(localStorage.getItem('currentSelectedData'));
                document.querySelector('#change-pdp-vehicle').setAttribute('data-id',currentData.id)
                if(currentData != null){
                    let isYearData = currentData.hasOwnProperty('year');
                    if(isYearData){
                        document.querySelector('#change-pdp-vehicle .year-default .option_txt').innerHTML = currentData.year;
                        document.querySelector('#change-pdp-vehicle .make-default .option_txt').innerHTML = currentData.make;
                        document.querySelector('#change-pdp-vehicle .model-default .option_txt').innerHTML = currentData.model;
                        document.querySelector('#change-pdp-vehicle .trim-default .option_txt').innerHTML = currentData.trim;
                        document.querySelector('#change-pdp-vehicle .cab-default .option_txt').innerHTML = currentData.cabType;
                        document.querySelector('#change-pdp-vehicle .heavy-equip-default .option_txt').innerHTML = "Equipment Type (optional)";
                        document.querySelector('#change-pdp-vehicle .manufacturer-default .option_txt').innerHTML = "Manufacturer";
                        document.querySelector('#change-pdp-vehicle .heavy-modal-default .option_txt').innerHTML = "Model Number";
                    } else {
                        document.querySelector('#change-pdp-vehicle .heavy-equip-default .option_txt').innerHTML = currentData.equipment_category;
                        document.querySelector('#change-pdp-vehicle .manufacturer-default .option_txt').innerHTML = currentData.equipment_manufacturer;
                        document.querySelector('#change-pdp-vehicle .heavy-modal-default .option_txt').innerHTML = currentData.equipment_model_number;
                        document.querySelector('#change-pdp-vehicle .year-default .option_txt').innerHTML = "Year";
                        document.querySelector('#change-pdp-vehicle .make-default .option_txt').innerHTML = "Make";
                        document.querySelector('#change-pdp-vehicle .model-default .option_txt').innerHTML = "Model";
                        document.querySelector('#change-pdp-vehicle .trim-default .option_txt').innerHTML = "Trim";
                        document.querySelector('#change-pdp-vehicle .cab-default .option_txt').innerHTML = "Cab Type";
                    }
                }
            
            });
        }

        this.editPDPYMMBtn = document.querySelector('[data-pdp-edit-vehicle-btn]');
        if(this.editPDPYMMBtn != undefined){
            this.editPDPYMMBtn.addEventListener('click',(event) => {
                event.target.closest('.btn').classList.add('loading');
                event.preventDefault();
                var prefixedParts = this.selectedPartNumber.map(function(element) {
                    return "sku-" + element;
                });
                var partsNumber = prefixedParts.join(",");

                let _this = event.currentTarget;
                let idToUpdate = _this.closest('#change-pdp-vehicle').getAttribute('data-id');
                let selectedYear = document.querySelector('#change-pdp-vehicle [data-year-filter-select] .selected [name="year-filter"]').getAttribute('data-label');
                let selectedMake = document.querySelector('#change-pdp-vehicle [data-make-filter-select] .selected [name="ymm-filter-make"]').getAttribute('data-label');
                let selectedModel = document.querySelector('#change-pdp-vehicle [data-modal-filter-select] .selected [name="ymm-filter-models"]').getAttribute('data-label');
                let selectedTrimEle = document.querySelector('#change-pdp-vehicle [data-trim-filter-select] .selected [name="ymm-filter-trim"]');
                let selectedTrim = selectedTrimEle ? selectedTrimEle.getAttribute('data-label') : "" ;
                let selectedCabEle = document.querySelector('#change-pdp-vehicle [data-cab-filter-select] .selected [name="ymm-filter-cab"]');
                let selectedCab = selectedCabEle ? selectedCabEle.getAttribute('data-label') : "" ;
                let selectedData = {
                    "id": idToUpdate,
                    "year":selectedYear,
                    "make":selectedMake,
                    "model":selectedModel,
                    "trim":selectedTrim,
                    "cabType":selectedCab
                }
                
                localStorage.setItem('currentSelectedData', JSON.stringify(selectedData))
                document.querySelector('#change-pdp-vehicle').hide();

                //this._redirectPage(rowURL, selectedYear, selectedMake, selectedModel, selectedTrim, selectedCab)
                this._redirectToParts(partsNumber);
            });
        }

        this.editPDPHEBtn = document.querySelectorAll('[data-pdp-edit-heavy-btn]');
        if(this.editPDPHEBtn != undefined){
            this.editPDPHEBtn.forEach(button => {
                button.addEventListener('click',(event) => {
                    event.preventDefault();
                    event.target.closest('.btn').classList.add('loading');
                    let _this = event.currentTarget;

                    let idToUpdate, selectedEqipType, selectedEqipManufacturer, selectedEqipModel;
                    if(_this.closest('#change-pdp-vehicle') != null){
                        idToUpdate = _this.closest('#change-pdp-vehicle').getAttribute('data-id');
                        
                        selectedEqipType = document.querySelector('#change-pdp-vehicle [data-heavy-category-select-filter] .selected [name="heavy-filter-type"]').getAttribute('data-label');
                        selectedEqipManufacturer = document.querySelector('#change-pdp-vehicle [data-heavy-manufacturer-select-filter] .selected [name="heavy-filter-manufacturer"]').getAttribute('data-label');
                        selectedEqipModel = document.querySelector('#change-pdp-vehicle [data-heavy-model-select-filter] .selected [name="heavy-filter-model-number"]').getAttribute('data-label');
                    }else if(_this.closest('#pdp-vehicle-model') != null){
                        idToUpdate = _this.closest('#pdp-vehicle-model').getAttribute('data-id');
                        
                        selectedEqipType = document.querySelector('#pdp-vehicle-model [data-heavy-category-select-filter] .selected [name="heavy-filter-type"]').getAttribute('data-label');
                        selectedEqipManufacturer = document.querySelector('#pdp-vehicle-model [data-heavy-manufacturer-select-filter] .selected [name="heavy-filter-manufacturer"]').getAttribute('data-label');
                        selectedEqipModel = document.querySelector('#pdp-vehicle-model [data-heavy-model-select-filter] .selected [name="heavy-filter-model-number"]').getAttribute('data-label');

                        // setCookie("pdp-popup-access","true", 24);
                    }
                   
                    let filteredParts;
                    filteredParts = [
                        ...new Set(
                            Object.values(window.globalVariables.heavyvehicleJson)
                                .filter(
                                    (item) =>
                                        item.equipment_manufacturer == selectedEqipManufacturer &&
                                        item.equipment_category == selectedEqipType &&
                                        item.equipment_model_number == selectedEqipModel
                                )
                                .map((item) => item.equipment_part_number)
                        ),
                    ];
                    var prefixedParts = filteredParts.map(function(element) {
                        return "sku-" + element;
                    });
                    var partsNumber = prefixedParts.join(",");
                   
                    let selectedData = {
                        "id": idToUpdate,
                        "equipment_category":selectedEqipType,
                        "equipment_manufacturer":selectedEqipManufacturer,
                        "equipment_model_number":selectedEqipModel
                    }
        
                    localStorage.setItem('currentSelectedData', JSON.stringify(selectedData))
    
                    if(document.querySelector('#change-vehicle')) 
                    document.querySelector('#change-vehicle').show();
                    this._redirectToParts(partsNumber);
                });
            });
        }
        // End PDP Change Vehicle

        //Account Change Vehicle 
        this.editVehcileBtn = document.querySelectorAll('[data-edit-vehcile]');
        this.editVehcileBtn.forEach((ele) => {
            ele.addEventListener('click',(event) => {
              
                event.preventDefault();
                event.stopPropagation();
                let _this = event.currentTarget;
                document.querySelector('#change-vehicle').show();
                let idToUpdate = _this.closest('[data-vehicle-id]').getAttribute('data-vehicle-id');
                const editYMMData = this.selectedYMMData.find(vehicle => vehicle.id == idToUpdate);
                document.querySelector('#change-vehicle').setAttribute('data-id',idToUpdate)
                if(editYMMData != undefined){
                    document.querySelector('#change-vehicle .year-default .option_txt').innerHTML = editYMMData.year;
                    document.querySelector('#change-vehicle .make-default .option_txt').innerHTML = editYMMData.make;
                    document.querySelector('#change-vehicle .model-default .option_txt').innerHTML = editYMMData.model;
                    document.querySelector('#change-vehicle .trim-default .option_txt').innerHTML = editYMMData.trim;
                    document.querySelector('#change-vehicle .cab-default .option_txt').innerHTML = editYMMData.cabType;
                    document.querySelector('#change-vehicle .heavy-equip-default .option_txt').innerHTML = "Equipment Type (optional)";
                    document.querySelector('#change-vehicle .manufacturer-default .option_txt').innerHTML = "Manufacturer";
                    document.querySelector('#change-vehicle .heavy-modal-default .option_txt').innerHTML = "Model Number";
                } 
            });
        });

        this.editYMMBtn = document.querySelector('[data-edit-shop-vehicle-btn]');
        if(this.editYMMBtn != null){
            this.editYMMBtn.addEventListener('click',(event) => {
                event.target.closest('.btn').classList.add('loading');
                event.preventDefault();
                let _this = event.currentTarget;
                this._editVehicle(_this);
    
            });
        }
        
       
        // End Change Account vehicle
        this._toggleAllDropdown();
    }

    _toggleAllDropdown(){
        document.querySelectorAll('[data-main-category]').forEach(element => {
            element.addEventListener('click', (event) => {
                this.querySelector('[data-year-wrap] .custom-dropdown .custom--select').classList.remove('open');
                this.querySelector('[data-model-wrap] .custom-dropdown .custom--select').classList.remove('open');
                this.querySelector('[data-trim-wrap] .custom-dropdown .custom--select').classList.remove('open');
                this.querySelector('[data-cab-wrap] .custom-dropdown.custom--select').classList.remove('open');
                this.querySelector('[data-year-wrap] .custom-dropdown.custom--select').classList.remove('open');
                this.querySelector('[data-model-wrap] .custom-dropdown.custom--select').classList.remove('open');
                this.querySelector('[data-trim-wrap] .custom-dropdown.custom--select').classList.remove('open');
                this.querySelector('[data-cab-wrap] .custom-dropdown.custom--select').classList.remove('open');
                this.querySelector('[data-year-wrap] .custom-dropdown .custom--select .toggle-content').classList.remove('open');
                this.querySelector('[data-model-wrap] .custom-dropdown .custom--select .toggle-content').classList.remove('open');
                this.querySelector('[data-trim-wrap] .custom-dropdown .custom--select .toggle-content').classList.remove('open');
                this.querySelector('[data-cab-wrap] .custom-dropdown.custom--select .toggle-content').classList.remove('open');
                this.querySelector('[data-make-wrap] .custom-dropdown .custom--select').classList.remove('open');
            });
        })
        this.querySelector('[data-make-wrap] .custom-dropdown')?.addEventListener('click', (event) => {
            this.querySelector('[data-year-wrap] .custom-dropdown .custom--select').classList.remove('open');
            this.querySelector('[data-model-wrap] .custom-dropdown .custom--select').classList.remove('open');
            this.querySelector('[data-trim-wrap] .custom-dropdown .custom--select').classList.remove('open');
            this.querySelector('[data-cab-wrap] .custom-dropdown.custom--select').classList.remove('open');
            this.querySelector('[data-year-wrap] .custom-dropdown.custom--select').classList.remove('open');
            this.querySelector('[data-model-wrap] .custom-dropdown.custom--select').classList.remove('open');
            this.querySelector('[data-trim-wrap] .custom-dropdown.custom--select').classList.remove('open');
            this.querySelector('[data-cab-wrap] .custom-dropdown.custom--select').classList.remove('open');
            this.querySelector('[data-year-wrap] .custom-dropdown .custom--select .toggle-content').classList.remove('open');
            this.querySelector('[data-model-wrap] .custom-dropdown .custom--select .toggle-content').classList.remove('open');
            this.querySelector('[data-trim-wrap] .custom-dropdown .custom--select .toggle-content').classList.remove('open');
            this.querySelector('[data-cab-wrap] .custom-dropdown.custom--select .toggle-content').classList.remove('open');
        });

        this.querySelector('[data-model-wrap] .custom-dropdown')?.addEventListener('click', (event) => {
            this.querySelector('[data-year-wrap] .custom-dropdown .custom--select').classList.remove('open');
            this.querySelector('[data-make-wrap] .custom-dropdown .custom--select').classList.remove('open');
            this.querySelector('[data-trim-wrap] .custom-dropdown .custom--select').classList.remove('open');
            this.querySelector('[data-cab-wrap] .custom-dropdown.custom--select').classList.remove('open');
            this.querySelector('[data-year-wrap] .custom-dropdown.custom--select').classList.remove('open');
            this.querySelector('[data-make-wrap] .custom-dropdown.custom--select').classList.remove('open');
            this.querySelector('[data-trim-wrap] .custom-dropdown.custom--select').classList.remove('open');
            this.querySelector('[data-cab-wrap] .custom-dropdown.custom--select').classList.remove('open');
            this.querySelector('[data-year-wrap] .custom-dropdown .custom--select .toggle-content').classList.remove('open');
            this.querySelector('[data-make-wrap] .custom-dropdown .custom--select .toggle-content').classList.remove('open');
            this.querySelector('[data-trim-wrap] .custom-dropdown .custom--select .toggle-content').classList.remove('open');
            this.querySelector('[data-cab-wrap] .custom-dropdown.custom--select .toggle-content').classList.remove('open');
        });

        this.querySelector('[data-year-wrap] .custom-dropdown')?.addEventListener('click', (event) => {
           
            this.querySelector('[data-make-wrap] .custom-dropdown .custom--select').classList.remove('open');
            this.querySelector('[data-model-wrap] .custom-dropdown .custom--select').classList.remove('open');
            this.querySelector('[data-trim-wrap] .custom-dropdown .custom--select').classList.remove('open');
            this.querySelector('[data-cab-wrap] .custom-dropdown.custom--select').classList.remove('open');
            this.querySelector('[data-make-wrap] .custom-dropdown.custom--select').classList.remove('open');
            this.querySelector('[data-model-wrap] .custom-dropdown.custom--select').classList.remove('open');
            this.querySelector('[data-trim-wrap] .custom-dropdown.custom--select').classList.remove('open');
            this.querySelector('[data-cab-wrap] .custom-dropdown.custom--select').classList.remove('open');
            this.querySelector('[data-make-wrap] .custom-dropdown .custom--select .toggle-content').classList.remove('open');
            this.querySelector('[data-model-wrap] .custom-dropdown .custom--select .toggle-content').classList.remove('open');
            this.querySelector('[data-trim-wrap] .custom-dropdown .custom--select .toggle-content').classList.remove('open');
            this.querySelector('[data-cab-wrap] .custom-dropdown.custom--select .toggle-content').classList.remove('open');
        });

        this.querySelector('[data-trim-wrap] .custom-dropdown')?.addEventListener('click', (event) => {
            this.querySelector('[data-make-wrap] .custom-dropdown .custom--select').classList.remove('open');
            this.querySelector('[data-model-wrap] .custom-dropdown .custom--select').classList.remove('open');
            this.querySelector('[data-year-wrap] .custom-dropdown .custom--select').classList.remove('open');
            this.querySelector('[data-cab-wrap] .custom-dropdown.custom--select').classList.remove('open');
            this.querySelector('[data-make-wrap] .custom-dropdown.custom--select').classList.remove('open');
            this.querySelector('[data-model-wrap] .custom-dropdown.custom--select').classList.remove('open');
            this.querySelector('[data-year-wrap] .custom-dropdown.custom--select').classList.remove('open');
            this.querySelector('[data-cab-wrap] .custom-dropdown.custom--select').classList.remove('open');
            this.querySelector('[data-make-wrap] .custom-dropdown .custom--select .toggle-content').classList.remove('open');
            this.querySelector('[data-model-wrap] .custom-dropdown .custom--select .toggle-content').classList.remove('open');
            this.querySelector('[data-year-wrap] .custom-dropdown .custom--select .toggle-content').classList.remove('open');
            this.querySelector('[data-cab-wrap] .custom-dropdown.custom--select .toggle-content').classList.remove('open');
        });

        this.querySelector('[data-cab-wrap] .custom-dropdown')?.addEventListener('click', (event) => {
            this.querySelector('[data-make-wrap] .custom-dropdown .custom--select').classList.remove('open');
            this.querySelector('[data-model-wrap] .custom-dropdown .custom--select').classList.remove('open');
            this.querySelector('[data-year-wrap] .custom-dropdown .custom--select').classList.remove('open');
            this.querySelector('[data-trim-wrap] .custom-dropdown.custom--select').classList.remove('open');
            this.querySelector('[data-make-wrap] .custom-dropdown.custom--select').classList.remove('open');
            this.querySelector('[data-model-wrap] .custom-dropdown.custom--select').classList.remove('open');
            this.querySelector('[data-year-wrap] .custom-dropdown.custom--select').classList.remove('open');
            this.querySelector('[data-trim-wrap] .custom-dropdown.custom--select').classList.remove('open');
            this.querySelector('[data-make-wrap] .custom-dropdown .custom--select .toggle-content').classList.remove('open');
            this.querySelector('[data-model-wrap] .custom-dropdown .custom--select .toggle-content').classList.remove('open');
            this.querySelector('[data-year-wrap] .custom-dropdown .custom--select .toggle-content').classList.remove('open');
            this.querySelector('[data-trim-wrap] .custom-dropdown.custom--select .toggle-content').classList.remove('open');
        });

    }

    _searchVehicle(){
        let selectedYear = this.querySelector('[data-year-filter-select] [name="year-filter"]:checked').value;
        let selectedMake = this.querySelector('[data-make-filter-select] [name="ymm-filter-make"]:checked').value;
        let selectedModel = this.querySelector('[data-modal-filter-select] [name="ymm-filter-models"]:checked').value;
        let selectedTrimEle = this.querySelector('[data-trim-filter-select] [name="ymm-filter-trim"]:checked');
        let selectedTrim = selectedTrimEle ? selectedTrimEle.value : "" ;
        let selectedCabEle = this.querySelector('[data-cab-filter-select] [name="ymm-filter-cab"]:checked');
        let selectedCab = selectedCabEle ? selectedCabEle.value : "" ;

        var prefixedParts = this.selectedPartNumber.map(function(element) {
            return "sku-" + element;
        });
        var partsNumber = prefixedParts.join(",");
        this._redirectToParts(partsNumber);
        
    }

    /**
     * 
     * @param {} partsNumber - selected vehicles 
     */
    _redirectToParts(partsNumber){
        window.location.href=`/collections/all?filter.p.tag=${partsNumber}`;
    }
    
    _addVehicle(){ 
        

        const isCustomer = document.body.classList.contains('customer-loggedin');
        // const isCustomerB2B = document.body.classList.contains('b2b-customer');

        var prefixedParts = this.selectedPartNumber.map(function(element) {
            return "sku-" + element;
        });
        var partsNumber = prefixedParts.join(",");

        let selectedYear = this.querySelector('[data-year-filter-select] [name="year-filter"]:checked').value;
        let selectedMake = this.querySelector('[data-make-filter-select] [name="ymm-filter-make"]:checked').value;
        let selectedModel = this.querySelector('[data-modal-filter-select] [name="ymm-filter-models"]:checked').value;
        let selectedTrimEle = this.querySelector('[data-trim-filter-select] [name="ymm-filter-trim"]:checked');
        let selectedTrim = selectedTrimEle ? selectedTrimEle.value : "" ;
        let selectedCabEle = this.querySelector('[data-cab-filter-select] [name="ymm-filter-cab"]:checked');
        let selectedCab = selectedCabEle ? selectedCabEle.value : "" ;
        let selectedYearlabel = this.querySelector('[data-year-filter-select] [name="year-filter"]:checked').getAttribute('data-label');
        let selectedMakeLabel = this.querySelector('[data-make-filter-select] [name="ymm-filter-make"]:checked').getAttribute('data-label');
        let selectedModelLabel = this.querySelector('[data-modal-filter-select] [name="ymm-filter-models"]:checked').getAttribute('data-label');
        let selectedTrimLabel = selectedTrimEle ? selectedTrimEle.getAttribute('data-label') : "" ;
        let selectedCabLabel = selectedCabEle ? selectedCabEle.getAttribute('data-label') : "" ;

        let selectedData;

        // var isVehicleAdded;
        // if(this.selectedYMMData != undefined){
        //     isVehicleAdded = this.selectedYMMData.some((selectedVehicle) => {
        //         return selectedVehicle.year === selectedYear && 
        //                 selectedVehicle.make === selectedMake && 
        //                 selectedVehicle.model === selectedModel && 
        //                 selectedVehicle.trim === selectedTrim && 
        //                 selectedVehicle.cabType === selectedCab;
        //     });
        // }

        var isVehicleAdded = this.selectedYMMData.some((selectedVehicle) => {
            return selectedVehicle.year === selectedYear && 
                    selectedVehicle.make === selectedMake && 
                    selectedVehicle.model === selectedModel && 
                    selectedVehicle.trim === selectedTrim && 
                    selectedVehicle.cabType === selectedCab;
        });
    
        const min = 1000;
        const max = 5000;
        const randomNum = Math.floor(Math.random() * (max - min + 1)) + min;
    
        if(!isVehicleAdded){
            // if (!Array.isArray(this.selectedYMMData)) {
            //     this.selectedYMMData = [];
            // }
            if(isCustomer){
                selectedData = {
                    "id": randomNum,
                    "year":selectedYearlabel,
                    "make":selectedMakeLabel,
                    "model":selectedModelLabel,
                    "trim":selectedTrimLabel,
                    "cabType":selectedCabLabel,
                    "default":this.defaultVehicle,
                }

                this.selectedYMMData.push(selectedData);
                
                localStorage.setItem('currentSelectedData', JSON.stringify(selectedData))
                localStorage.setItem('currentSelectedDataLabels', JSON.stringify(selectedData))

                shopifyFormUtility._updateVehicleMeta(this.selectedYMMData,partsNumber);
                
                //shopifyFormUtility._shopifyVehicleFormSubmit(this.selectedYMMData,partsNumber);
              
                setTimeout(() => {
                    let vehicleMeta = document.querySelector('[data-vehile-customer-metafields] [data-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedYMMData = vehicleMeta != '' ? JSON.parse(vehicleMeta) : [];
                  
                    let heavyMeta = document.querySelector('[data-vehile-customer-metafields] [data-hevay-equp-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedHeavyEqipData = heavyMeta != '' ? JSON.parse(heavyMeta) : [];

                    let sideMeta = document.querySelector('[data-vehile-customer-metafields] [data-side-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedSideYMMData = sideMeta != '' ? JSON.parse(sideMeta) : [];

                    let turfMeta = document.querySelector('[data-vehile-customer-metafields] [data-turf-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedTrufData = turfMeta != '' ? JSON.parse(turfMeta) : [];

                    localStorage.removeItem('vehicle_data');
                    localStorage.removeItem('heavy_equipment_data');
                    vehicleUtility._listVehicle();
                    // this._listVehicleEvents();
                    this._redirectToParts(partsNumber);
                    let datashopvehiclebtn = this.querySelectorAll('[data-shop-vehicle-btn]')
                    datashopvehiclebtn.forEach(button => {
                        button.classList.remove('loading');
                    })
                    this.querySelector('[data-shop-vehicle-btn-new]')?.classList.remove('loading');
                  
                },3000);

                
            }  else {
                selectedData = {
                        "id": randomNum,
                        "year":selectedYear,
                        "make":selectedMake,
                        "model":selectedModel,
                        "trim":selectedTrim,
                        "cabType":selectedCab,
                        "default":this.defaultVehicle,
                }

                this.selectedYMMData.push(selectedData);
                var prefixedParts = this.selectedPartNumber.map(function(element) {
                    return "sku-" + element;
                });
                var partsNumber = prefixedParts.join(",");


                let selectedYearLabel = this.querySelector('[data-year-filter-select] [name="year-filter"]:checked').getAttribute('data-label');
                let selectedMakeLabel = this.querySelector('[data-make-filter-select] [name="ymm-filter-make"]:checked').getAttribute('data-label');
                let selectedModelLabel = this.querySelector('[data-modal-filter-select] [name="ymm-filter-models"]:checked').getAttribute('data-label');
                let selectedTrimEle = this.querySelector('[data-trim-filter-select] [name="ymm-filter-trim"]:checked');
                let selectedTrimLabel = selectedTrimEle ? selectedTrimEle.getAttribute('data-label') : "" ;
                let selectedCabEle = this.querySelector('[data-cab-filter-select] [name="ymm-filter-cab"]:checked');
                let selectedCabLabel = selectedCabEle ? selectedCabEle.getAttribute('data-label') : "" ;
               
                var selectedDataLabel = {
                    "id": randomNum,
                    "year":selectedYearLabel,
                    "make":selectedMakeLabel,
                    "model":selectedModelLabel,
                    "trim":selectedTrimLabel,
                    "cabType":selectedCabLabel,
                }

                localStorage.setItem('currentSelectedDataLabels', JSON.stringify(selectedDataLabel));
                localStorage.setItem('currentSelectedData', JSON.stringify(selectedData));



                localStorage.setItem('vehicle_data', JSON.stringify(this.selectedYMMData))
                const addedHeavyData = localStorage.getItem('heavy_equipment_data');
                this.selectedHeavyEqipData = addedHeavyData ? JSON.parse(addedHeavyData) : [];

                const addedSideData = localStorage.getItem('vehicle_data_side');
                this.selectedSideYMMData = addedSideData ? JSON.parse(addedSideData) : [];

                vehicleUtility._listVehicle();
                // this._listVehicleEvents();
                this._redirectToParts(partsNumber);
                setTimeout(() => {
                    let datashopvehiclebtn = this.querySelectorAll('[data-shop-vehicle-btn]')
                    datashopvehiclebtn.forEach(button => {
                        button.classList.remove('loading');
                    })
                    
                    this.querySelector('[data-shop-vehicle-btn-new]')?.classList.remove('loading');
                },3000);
            }
        } else {
            this._redirectToParts(partsNumber);
        }
       
    }


    _editVehicle(_this){
        var prefixedParts = this.selectedPartNumber.map(function(element) {
            return "sku-" + element;
        });
        var partsNumber = prefixedParts.join(",");

        let idToUpdate = _this.closest('#change-vehicle').getAttribute('data-id');
        let selectedYear = document.querySelector('#change-vehicle [data-year-filter-select] .selected [name="year-filter"]').value;
        let selectedMake = document.querySelector('#change-vehicle [data-make-filter-select] .selected [name="ymm-filter-make"]').value;
        let selectedModel = document.querySelector('#change-vehicle [data-modal-filter-select] .selected [name="ymm-filter-models"]').value;
        let selectedTrimEle = document.querySelector('#change-vehicle [data-trim-filter-select] .selected [name="ymm-filter-trim"]');
        let selectedTrim = selectedTrimEle ? selectedTrimEle.value : "" ;
        let selectedCabEle = document.querySelector('#change-vehicle [data-cab-filter-select] .selected [name="ymm-filter-cab"]');
        let selectedCab = selectedCabEle ? selectedCabEle.value : "" ;
        let isCustomer = document.body.classList.contains('customer-loggedin');

        for (let i = 0; i <  this.selectedYMMData.length; i++) {
            if (this.selectedYMMData[i].id == idToUpdate) {
              this.selectedYMMData[i].year = selectedYear;
              this.selectedYMMData[i].make = selectedMake;
              this.selectedYMMData[i].model = selectedModel;
              this.selectedYMMData[i].trim = selectedTrim;
              this.selectedYMMData[i].cabType = selectedCab;
            }  
        }

        let selectedData = {
            "id": idToUpdate,
            "year":selectedYear,
            "make":selectedMake,
            "model":selectedModel,
            "trim":selectedTrim,
            "cabType":selectedCab
        }

        if(isCustomer){
            // shopifyFormUtility._shopifyVehicleFormSubmit(this.selectedYMMData);
            shopifyFormUtility._updateVehicleMeta(this.selectedYMMData);
            let vehicleMeta = document.querySelector('[data-vehile-customer-metafields] [data-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
            this.selectedYMMData = vehicleMeta != '' ? JSON.parse(vehicleMeta) : [];
            
            let heavyMeta = document.querySelector('[data-vehile-customer-metafields] [data-hevay-equp-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
            this.selectedHeavyEqipData = heavyMeta != '' ? JSON.parse(heavyMeta) : [];

            let sideMeta = document.querySelector('[data-vehile-customer-metafields] [data-side-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
            this.selectedSideYMMData = sideMeta != '' ? JSON.parse(sideMeta) : [];

            let turfMeta = document.querySelector('[data-vehile-customer-metafields] [data-turf-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
            this.selectedTrufData = turfMeta != '' ? JSON.parse(turfMeta) : [];
            vehicleUtility._listAccountVehicle();
            this._listVehicleEvents();
            
            setTimeout(()=>{    
                this._redirectToParts(partsNumber);
                document.querySelector('[data-edit-shop-vehicle-btn]').classList.remove('loading');
            },1500)            
        } else {
            localStorage.setItem('vehicle_data', JSON.stringify(this.selectedYMMData))
            this._redirectToParts(partsNumber);
        }
        localStorage.setItem('currentSelectedData', JSON.stringify(selectedData))
        localStorage.setItem('currentSelectedDataLabels', JSON.stringify(selectedData))

        
        document.querySelector('#change-vehicle').show();
    }
    
    // List add, remove, update, and clear event
    _listVehicleEvents(){
        //Remove Vehicle
        this.removeVehicleEle = document.querySelectorAll('[data-remove-vehicle]');
        this.removeVehicleEle.forEach((removeEle) => {
            removeEle.addEventListener('click',(event) => {
                event.preventDefault();
                let _this = event.currentTarget;
                this._removeVehicle(_this);
            });
        });

        // Shop vehicle btn
        let shopBtns = document.querySelectorAll('[data-shop-vehiclebtn]');
        shopBtns.forEach((shopBtn) => {
            shopBtn.addEventListener('click',(event) => {
                event.stopImmediatePropagation();
                event.preventDefault();
                let _this = event.currentTarget;
                _this.closest(".vehicle-item").querySelector('[data-list-vehicle-checkbox]').click();
                this._shopBtn(_this);
            });
        });

        //Change Default Vehcile Selection
        this.updateDefaultVehicleEle = document.querySelectorAll('[data-list-vehicle-checkbox]');
        this.updateDefaultVehicleEle.forEach((updateEle) => {
            updateEle.addEventListener('change',(event) => {
                event.stopImmediatePropagation();
                event.preventDefault();
                let _this = event.currentTarget;
                // console.log(_this.getAttribute("name"))
                // if(_this.getAttribute("name") == "list-vehicle-pdp-list"){
                //     setCookie("pdp-popup-access","true", 24);
                // }
                this._updateDefault(_this);
            });
        });

        let clearBtns = document.querySelectorAll('[data-clear-vehicle-data]');
        clearBtns.forEach((clearBtn) => {
            clearBtn.addEventListener('click',(event) => {
                event.preventDefault();
                this._clearVehicleData();
            });
        });

        // document.querySelector('[data-clear-vehicle-data]').addEventListener('click',(event) => {
        //     event.preventDefault();
        //     this._clearVehicleData();
        // });
    }

    _clearVehicleData(){

        this.selectedYMMData = [];
        this.selectedHeavyEqipData = [];
        this.selectedSideYMMData = [];
        this.selectedTrufData = [];
        this.selectedSahdtData = [];

        //shopifyFormUtility._shopifyVehicleFormSubmit(this.selectedYMMData);
        shopifyFormUtility._updateVehicleMeta(this.selectedYMMData);

        //shopifyFormUtility._shopifyHEFormSubmit(this.selectedHeavyEqipData);
        shopifyFormUtility._updateCustomerHEMeta(this.selectedHeavyEqipData);


        //shopifyFormUtility._shopifySideFormSubmit(this.selectedSideYMMData);
        shopifyFormUtility._updateCustomerSideMeta(this.selectedSideYMMData);

        //shopifyFormUtility._shopifyTurfFormSubmit(this.selectedTrufData);
        shopifyFormUtility._updateCustomerTurfMeta(this.selectedTrufData);

        shopifyFormUtility._updateCustomerSHeavyMeta(this.selectedSahdtData);

        window.customerSelectedVehicles.vehicle = [];
        window.customerSelectedVehicles.heavyVehicle = [];
        window.customerSelectedVehicles.sidebyside = [];
        window.customerSelectedVehicles.turf = [];
    
        localStorage.removeItem('vehicle_data');
        localStorage.removeItem('heavy_equipment_data');
        localStorage.removeItem('turf_data');
        localStorage.removeItem('vehicle_data_sahdt');
        localStorage.removeItem('vehicle_data_side');

        vehicleUtility._listVehicle();
        this._listVehicleEvents();

        if(document.body.classList.contains('template-account')){
            vehicleUtility._listAccountVehicle();
            this._listVehicleEvents();
        }
        // setTimeout(() => {
        //     window.location.reload();
        // },2000);
    }

    _removeVehicle(_this){
        let isCustomer = document.body.classList.contains('customer-loggedin');
        let idToRemove = _this.closest('[data-vehicle-id]').getAttribute('data-vehicle-id');

        for (let i = 0; i <  this.selectedSahdtData.length; i++) {
            if ( this.selectedSahdtData[i].id == idToRemove) {
              this.selectedSahdtData.splice(i, 1);
              if(isCustomer){
                //shopifyFormUtility._shopifySemiAndHeavyDutyFormSubmit(this.selectedSahdtData);
                shopifyFormUtility._updateCustomerSHeavyMeta(this.selectedSahdtData);

                setTimeout(() => {
                    let vehicleMeta = document.querySelector('[data-vehile-customer-metafields] [data-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedYMMData = vehicleMeta != '' ? JSON.parse(vehicleMeta) : [];
                  
                    let heavyMeta = document.querySelector('[data-vehile-customer-metafields] [data-hevay-equp-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedHeavyEqipData = heavyMeta != '' ? JSON.parse(heavyMeta) : [];

                    let sideMeta = document.querySelector('[data-vehile-customer-metafields] [data-side-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedSideYMMData = sideMeta != '' ? JSON.parse(sideMeta) : [];

                    let turfMeta = document.querySelector('[data-vehile-customer-metafields] [data-turf-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedTrufData = turfMeta != '' ? JSON.parse(turfMeta) : [];

                    let sahdtMeta = document.querySelector('[data-vehile-customer-metafields] [data-sahdt-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedSahdtData = sahdtMeta != '' ? JSON.parse(sahdtMeta) : [];
                    
                    // window.location.reload();
                },2000);
                
                
              } else {
                localStorage.setItem('vehicle_data_sahdt', JSON.stringify(this.selectedSahdtData))
              }
              break; 
            }
        }

        for (let i = 0; i <  this.selectedYMMData.length; i++) {
            if ( this.selectedYMMData[i].id == idToRemove) {
              this.selectedYMMData.splice(i, 1);
              if(isCustomer){
                //shopifyFormUtility._shopifyVehicleFormSubmit(this.selectedYMMData);
                shopifyFormUtility._updateVehicleMeta(this.selectedYMMData);

                setTimeout(() => {
                    let vehicleMeta = document.querySelector('[data-vehile-customer-metafields] [data-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedYMMData = vehicleMeta != '' ? JSON.parse(vehicleMeta) : [];
                  
                    let heavyMeta = document.querySelector('[data-vehile-customer-metafields] [data-hevay-equp-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedHeavyEqipData = heavyMeta != '' ? JSON.parse(heavyMeta) : [];

                    let sideMeta = document.querySelector('[data-vehile-customer-metafields] [data-side-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedSideYMMData = sideMeta != '' ? JSON.parse(sideMeta) : [];

                    let turfMeta = document.querySelector('[data-vehile-customer-metafields] [data-turf-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedTrufData = turfMeta != '' ? JSON.parse(turfMeta) : [];

                    let sahdtMeta = document.querySelector('[data-vehile-customer-metafields] [data-sahdt-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedSahdtData = sahdtMeta != '' ? JSON.parse(sahdtMeta) : [];
                    
                    // window.location.reload();
                },2000);
                
                
              } else {
                localStorage.setItem('vehicle_data', JSON.stringify(this.selectedYMMData))
              }
              break; 
            }
        }

        for (let i = 0; i <  this.selectedHeavyEqipData.length; i++) {
            if ( this.selectedHeavyEqipData[i].id == idToRemove) {
              this.selectedHeavyEqipData.splice(i, 1);
              if(isCustomer){
                //shopifyFormUtility._shopifyHEFormSubmit(this.selectedHeavyEqipData);
                shopifyFormUtility._updateCustomerHEMeta(this.selectedHeavyEqipData);

                setTimeout(() => {
                    let vehicleMeta = document.querySelector('[data-vehile-customer-metafields] [data-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedYMMData = vehicleMeta != '' ? JSON.parse(vehicleMeta) : [];
                  
                    let heavyMeta = document.querySelector('[data-vehile-customer-metafields] [data-hevay-equp-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedHeavyEqipData = heavyMeta != '' ? JSON.parse(heavyMeta) : [];
                    
                    let sideMeta = document.querySelector('[data-vehile-customer-metafields] [data-side-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedSideYMMData = sideMeta != '' ? JSON.parse(sideMeta) : [];

                    let turfMeta = document.querySelector('[data-vehile-customer-metafields] [data-turf-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedTrufData = turfMeta != '' ? JSON.parse(turfMeta) : [];

                    let sahdtMeta = document.querySelector('[data-vehile-customer-metafields] [data-sahdt-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedSahdtData = sahdtMeta != '' ? JSON.parse(sahdtMeta) : [];

                    // window.location.reload();
                },2000);
              } else {
                localStorage.setItem('heavy_equipment_data', JSON.stringify(this.selectedHeavyEqipData))
              }
              break; 
            }
        }

        for (let i = 0; i <  this.selectedSideYMMData.length; i++) {
            if ( this.selectedSideYMMData[i].id == idToRemove) {
              this.selectedSideYMMData.splice(i, 1);
              if(isCustomer){
                //shopifyFormUtility._shopifySideFormSubmit(this.selectedSideYMMData);
                shopifyFormUtility._updateCustomerSideMeta(this.selectedSideYMMData);

                setTimeout(() => {
                    let vehicleMeta = document.querySelector('[data-vehile-customer-metafields] [data-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedYMMData = vehicleMeta != '' ? JSON.parse(vehicleMeta) : [];
                  
                    let heavyMeta = document.querySelector('[data-vehile-customer-metafields] [data-hevay-equp-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedHeavyEqipData = heavyMeta != '' ? JSON.parse(heavyMeta) : [];

                    let sideMeta = document.querySelector('[data-vehile-customer-metafields] [data-side-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedSideYMMData = sideMeta != '' ? JSON.parse(sideMeta) : [];

                    let turfMeta = document.querySelector('[data-vehile-customer-metafields] [data-turf-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedTrufData = turfMeta != '' ? JSON.parse(turfMeta) : [];

                    let sahdtMeta = document.querySelector('[data-vehile-customer-metafields] [data-sahdt-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedSahdtData = sahdtMeta != '' ? JSON.parse(sahdtMeta) : [];
                    
                    // window.location.reload();
                },2000);
                
                
              } else {
                localStorage.setItem('vehicle_data_side', JSON.stringify(this.selectedSideYMMData))
              }
              break; 
            }
        }

        for (let i = 0; i <  this.selectedTrufData.length; i++) {
            if ( this.selectedTrufData[i].id == idToRemove) {
              this.selectedTrufData.splice(i, 1);
              if(isCustomer){
                //shopifyFormUtility._shopifyTurfFormSubmit(this.selectedTrufData);
                shopifyFormUtility._updateCustomerTurfMeta(this.selectedTrufData);

                setTimeout(() => {
                    let vehicleMeta = document.querySelector('[data-vehile-customer-metafields] [data-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedYMMData = vehicleMeta != '' ? JSON.parse(vehicleMeta) : [];
                  
                    let heavyMeta = document.querySelector('[data-vehile-customer-metafields] [data-hevay-equp-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedHeavyEqipData = heavyMeta != '' ? JSON.parse(heavyMeta) : [];
                    
                    let sideMeta = document.querySelector('[data-vehile-customer-metafields] [data-side-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedSideYMMData = sideMeta != '' ? JSON.parse(sideMeta) : [];

                    let turfMeta = document.querySelector('[data-vehile-customer-metafields] [data-turf-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedTrufData = turfMeta != '' ? JSON.parse(turfMeta) : [];

                    let sahdtMeta = document.querySelector('[data-vehile-customer-metafields] [data-sahdt-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedSahdtData = sahdtMeta != '' ? JSON.parse(sahdtMeta) : [];

                    // window.location.reload();
                },2000);
              } else {
                localStorage.setItem('turf_data', JSON.stringify(this.selectedTrufData))
              }
              break; 
            }
        }

        vehicleUtility._deterMineVehicles();
        vehicleUtility._listVehicle();
        this._listVehicleEvents();

        if(document.body.classList.contains('template-account')){
            vehicleUtility._listAccountVehicle();
            this._listVehicleEvents();
        }
    }

    _shopBtn(_this){
        let isCustomer = document.body.classList.contains('customer-loggedin');
        let idToUpdate = _this.closest('[data-vehicle-id]').getAttribute('data-vehicle-id');
        const isYMMVehicle = this.selectedYMMData.some(vehicle => vehicle.id == idToUpdate);
        const isturfVehicle = this.selectedTrufData.some( vehicle => vehicle.id == idToUpdate);
        const isSahdtVehicle = this.selectedSahdtData.some( vehicle => vehicle.id == idToUpdate );
        const isHeavyVehicle = this.selectedHeavyEqipData.some( vehicle => vehicle.id == idToUpdate );
        const isSSVehicle = this.selectedSideYMMData.some( vehicle => vehicle.id == idToUpdate );
    
        let selectedYear = "";
        let selectedMake = "";
        let selectedModel = "";
        let selectedTrim = "";
        let selectedCab = "";
        let selectedEqipType = "";
        let selectedEqipManufacturer = "";
        let selectedEqipModel = "";
        let selectedTurfType = "";
        let selectedTurfManufacturer = "";
        let selectedTurfModel = "";
        let turfJson = null;
        let selectedYearData = {
            "id": "",
            "year":"",
            "make":"",
            "model":"",
            "trim":"",
            "cabType":""
        }
    
        let selectedSSYearData = {
            "id": "",
            "year":"",
            "make":"",
            "model":""
        }
    
        let selectedEquipData = {
            "id": "",
            "equipment_category":"",
            "equipment_manufacturer":"",
            "equipment_model_number":""
        }
    
        let selectedTurfData = {
            "id": "",
            "equipment_category":"",
            "equipment_manufacturer":"",
            "equipment_model_number":""
        }
    
        let sahdtData = {
            "id": "",
            "year":"",
            "make":"",
            "model":""
        }

        if(isYMMVehicle){
            for (let i = 0; i <  this.selectedYMMData.length; i++) {                
                if (this.selectedYMMData[i].id == idToUpdate) {
                    selectedYear = this.selectedYMMData[i].year;
                    selectedMake = this.selectedYMMData[i].make;
                    selectedModel = this.selectedYMMData[i].model;
                    selectedTrim = this.selectedYMMData[i].trim;
                    selectedCab = this.selectedYMMData[i].cabType;
    
                    selectedYearData.id = this.selectedYMMData[i].id;
                    selectedYearData.year = selectedYear;
                    selectedYearData.make = selectedMake;
                    selectedYearData.model = selectedModel;
                    selectedYearData.trim = selectedTrim;
                    selectedYearData.cabType = selectedCab;
                }
            }
    
            if(selectedTrim != '' && selectedCab != ''){       
                this._updateDefaultSelection('shopbtn',selectedYearData,selectedYear, selectedMake, selectedModel, selectedTrim, selectedCab);
            } else if (selectedTrim != '' && selectedCab == ''){
                this._updateDefaultSelection('shopbtn',selectedYearData,selectedYear, selectedMake, selectedModel, selectedTrim);
            } else {
                this._updateDefaultSelection('shopbtn',selectedYearData,selectedYear, selectedMake, selectedModel, "", "");
            }
    
        } else if(isHeavyVehicle && !isSahdtVehicle) {
            for (let i = 0; i <  this.selectedHeavyEqipData.length; i++) {
                if (this.selectedHeavyEqipData[i].id == idToUpdate) {
                    selectedEqipType = this.selectedHeavyEqipData[i].equipment_category;
                    selectedEqipManufacturer = this.selectedHeavyEqipData[i].equipment_manufacturer;
                    selectedEqipModel = this.selectedHeavyEqipData[i].equipment_model_number;
        
                    selectedEquipData.id = this.selectedHeavyEqipData[i].id;
                    selectedEquipData.equipment_category = selectedEqipType;
                    selectedEquipData.equipment_manufacturer = selectedEqipManufacturer;
                    selectedEquipData.equipment_model_number = selectedEqipModel;
                }
            }
    
            let filteredParts;
            filteredParts = [
                ...new Set(
                    Object.values(window.globalVariables.heavyvehicleJson)
                        .filter(
                            (item) =>
                                item.equipment_manufacturer == selectedEqipManufacturer &&
                                item.equipment_category == selectedEqipType &&
                                item.equipment_model_number == selectedEqipModel
                        )
                        .map((item) => item.equipment_part_number)
                ),
            ];
    
            var prefixedParts = filteredParts.map(function(element) {
                return "sku-" + element;
            });
            var partsNumber = prefixedParts.join(",");
    
    
            if(isCustomer){
            
                setTimeout(() => {
                    let vehicleMeta = document.querySelector('[data-vehile-customer-metafields] [data-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedYMMData = vehicleMeta != '' ? JSON.parse(vehicleMeta) : [];
                  
                    let heavyMeta = document.querySelector('[data-vehile-customer-metafields] [data-hevay-equp-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedHeavyEqipData = heavyMeta != '' ? JSON.parse(heavyMeta) : [];
    
                    let sideMeta = document.querySelector('[data-vehile-customer-metafields] [data-side-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedSideYMMData = sideMeta != '' ? JSON.parse(sideMeta) : [];
    
                    let turfMeta = document.querySelector('[data-vehile-customer-metafields] [data-turf-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedTrufData = turfMeta != '' ? JSON.parse(turfMeta) : [];
    
                    let sahdtMeta = document.querySelector('[data-vehile-customer-metafields] [data-sahdt-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedSahdtData = sahdtMeta != '' ? JSON.parse(sahdtMeta) : [];
    
                    localStorage.setItem('currentSelectedData', JSON.stringify(selectedEquipData))
                    localStorage.setItem('currentSelectedDataLabels', JSON.stringify(selectedYearData))
    
                    if(partsNumber != undefined){
                        window.location.href=`/collections/all?filter.p.tag=${partsNumber}`;
                    }
                    else{
                        window.location.href=`/collections/all`;
                    }
    
                },2000);
                
            } else {
                localStorage.setItem('vehicle_data', JSON.stringify(this.selectedYMMData))
                localStorage.setItem('heavy_equipment_data', JSON.stringify(this.selectedHeavyEqipData))    
                localStorage.setItem('turf_data', JSON.stringify(this.selectedTrufData))    
                localStorage.setItem('vehicle_data_sahdt', JSON.stringify(this.selectedSahdtData))  
                localStorage.setItem('vehicle_data_side', JSON.stringify(this.selectedSideYMMData))    
    
                localStorage.setItem('currentSelectedData', JSON.stringify(selectedEquipData))
                localStorage.setItem('currentSelectedDataLabels', JSON.stringify(selectedEquipData))
    
                if(partsNumber != undefined){
                    window.location.href=`/collections/all?filter.p.tag=${partsNumber}`;
                }
                else{
                    window.location.href=`/collections/all`;
                }
    
            }
        } else if(isturfVehicle){
            for (let i = 0; i <  this.selectedTrufData.length; i++) {
                if (this.selectedTrufData[i].id == idToUpdate) {
                    selectedTurfType = this.selectedTrufData[i].equipment_category;
                    selectedTurfManufacturer = this.selectedTrufData[i].equipment_manufacturer;
                    selectedTurfModel = this.selectedTrufData[i].equipment_model_number;
        
                    selectedTurfData.id = this.selectedTrufData[i].id;
                    selectedTurfData.equipment_category = selectedTurfType;
                    selectedTurfData.equipment_manufacturer = selectedTurfManufacturer;
                    selectedTurfData.equipment_model_number = selectedTurfModel;
                }
            }
    
            let filteredParts;
            filteredParts = [
                ...new Set(
                    Object.values(window.globalVariables.agriTurfVehicleJson)
                        .filter(
                            (item) =>
                                item.equipment_manufacturer == selectedTurfManufacturer &&
                                item.equipment_category == selectedTurfType &&
                                item.equipment_model_number == selectedTurfModel
                        )
                        .map((item) => item.equipment_part_number)
                ),
            ];
    
            var prefixedParts = filteredParts.map(function(element) {
                return "sku-" + element;
            });
            var partsNumber = prefixedParts.join(",");
            if(isCustomer){
    
                setTimeout(() => {
                    let vehicleMeta = document.querySelector('[data-vehile-customer-metafields] [data-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedYMMData = vehicleMeta != '' ? JSON.parse(vehicleMeta) : [];
                  
                    let heavyMeta = document.querySelector('[data-vehile-customer-metafields] [data-hevay-equp-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedHeavyEqipData = heavyMeta != '' ? JSON.parse(heavyMeta) : [];
    
                    let sideMeta = document.querySelector('[data-vehile-customer-metafields] [data-side-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedSideYMMData = sideMeta != '' ? JSON.parse(sideMeta) : [];
    
                    let turfMeta = document.querySelector('[data-vehile-customer-metafields] [data-turf-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedTrufData = turfMeta != '' ? JSON.parse(turfMeta) : [];
                    
                    let sahdtMeta = document.querySelector('[data-vehile-customer-metafields] [data-sahdt-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedSahdtData = sahdtMeta != '' ? JSON.parse(sahdtMeta) : [];
                    
                    localStorage.setItem('currentSelectedData', JSON.stringify(selectedTurfData))
                    localStorage.setItem('currentSelectedDataLabels', JSON.stringify(selectedTurfData))
                    if(partsNumber != undefined){
                        window.location.href=`/collections/all?filter.p.tag=${partsNumber}`;
                    }
                    else{
                        window.location.href=`/collections/agriculture-turf-covers`;
                    }
    
                },2000);
                
            } else {
                localStorage.setItem('vehicle_data', JSON.stringify(this.selectedYMMData))
                localStorage.setItem('heavy_equipment_data', JSON.stringify(this.selectedHeavyEqipData))    
                localStorage.setItem('turf_data', JSON.stringify(this.selectedTrufData))    
                localStorage.setItem('vehicle_data_sahdt', JSON.stringify(this.selectedSahdtData))  
                localStorage.setItem('vehicle_data_side', JSON.stringify(this.selectedSideYMMData))    
                
                localStorage.setItem('currentSelectedData', JSON.stringify(selectedTurfData))
                localStorage.setItem('currentSelectedDataLabels', JSON.stringify(selectedTurfData))

                if(partsNumber != undefined){
                    window.location.href=`/collections/all?filter.p.tag=${partsNumber}`;
                }
                else{
                    window.location.href=`/collections/agriculture-turf-covers`;
                }
            }
        } else if(isSSVehicle){
            for (let i = 0; i <  this.selectedSideYMMData.length; i++) {
                    selectedYear = this.selectedSideYMMData[i].year;
                    selectedMake = this.selectedSideYMMData[i].make;
                    selectedModel = this.selectedSideYMMData[i].model;
    
                    selectedSSYearData.id = this.selectedSideYMMData[i].id;
                    selectedSSYearData.year = selectedYear;
                    selectedSSYearData.make = selectedMake;
                    selectedSSYearData.model = selectedModel;
            }
    
            let filteredParts;
            filteredParts = [
                ...new Set(
                    Object.values(window.globalVariables.sidevehicleJson)
                        .filter(
                            (item) =>
                                item.year == selectedYear &&
                                item.make == selectedMake &&
                                item.model == selectedModel
                        )
                        .map((item) => item.part_number)
                ),
            ];
    
            var prefixedParts = filteredParts.map(function(element) {
                return "sku-" + element;
            });
            var partsNumber = prefixedParts.join(",");
            
            if(isCustomer){
               
               setTimeout(() => {
                   let vehicleMeta = document.querySelector('[data-vehile-customer-metafields] [data-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                   this.selectedYMMData = vehicleMeta != '' ? JSON.parse(vehicleMeta) : [];
                 
                   let heavyMeta = document.querySelector('[data-vehile-customer-metafields] [data-hevay-equp-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                   this.selectedHeavyEqipData = heavyMeta != '' ? JSON.parse(heavyMeta) : [];
    
                   let sideMeta = document.querySelector('[data-vehile-customer-metafields] [data-side-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                   this.selectedSideYMMData = sideMeta != '' ? JSON.parse(sideMeta) : [];
    
                   let turfMeta = document.querySelector('[data-vehile-customer-metafields] [data-turf-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                   this.selectedTrufData = turfMeta != '' ? JSON.parse(turfMeta) : [];
                   
                   localStorage.setItem('currentSelectedDataLabels', JSON.stringify(selectedSSYearData))
    
                if(partsNumber != undefined){
                    window.location.href=`/collections/all?filter.p.tag=${partsNumber}`;
                }
                else{
                    window.location.href=`/collections/side-by-side-seat-covers`;
                }
    
               },2000);
               
           } else {
            localStorage.setItem('vehicle_data', JSON.stringify(this.selectedYMMData))
            localStorage.setItem('heavy_equipment_data', JSON.stringify(this.selectedHeavyEqipData))    
            localStorage.setItem('turf_data', JSON.stringify(this.selectedTrufData))    
            localStorage.setItem('vehicle_data_sahdt', JSON.stringify(this.selectedSahdtData))  
            localStorage.setItem('vehicle_data_side', JSON.stringify(this.selectedSideYMMData))    
    
            localStorage.setItem('currentSelectedData', JSON.stringify(selectedYearData))
            localStorage.setItem('currentSelectedDataLabels', JSON.stringify(selectedSSYearData))
    
            if(partsNumber != undefined){
                window.location.href=`/collections/all?filter.p.tag=${partsNumber}`;
            }
            else{
                window.location.href=`/collections/side-by-side-seat-covers`;
            }
    
           }
    
        } else if(isSahdtVehicle){
            for (let i = 0; i <  this.selectedSahdtData.length; i++) {
                sahdtData.id = this.selectedSahdtData[i].id;
                sahdtData.year = this.selectedSahdtData[i].year;
                sahdtData.make = this.selectedSahdtData[i].make;
                sahdtData.model = this.selectedSahdtData[i].model;
            }
    
    
            let filteredParts;
            filteredParts = [
                ...new Set(
                    Object.values(window.globalVariables.sahdtJson)
                        .filter(
                            (item) =>
                                item.year == sahdtData.year &&
                                item.make == sahdtData.make &&
                                item.model == sahdtData.model
                        )
                        .map((item) => item.part_number)
                ),
            ];
    
            var prefixedParts = filteredParts.map(function(element) {
                return "sku-" + element;
            });
            var partsNumber = prefixedParts.join(",");
    
    
            if(isCustomer){
              
                setTimeout(() => {
                    let vehicleMeta = document.querySelector('[data-vehile-customer-metafields] [data-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedYMMData = vehicleMeta != '' ? JSON.parse(vehicleMeta) : [];
                  
                    let heavyMeta = document.querySelector('[data-vehile-customer-metafields] [data-hevay-equp-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedHeavyEqipData = heavyMeta != '' ? JSON.parse(heavyMeta) : [];
    
                    let sideMeta = document.querySelector('[data-vehile-customer-metafields] [data-side-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedSideYMMData = sideMeta != '' ? JSON.parse(sideMeta) : [];
    
                    let turfMeta = document.querySelector('[data-vehile-customer-metafields] [data-turf-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedTrufData = turfMeta != '' ? JSON.parse(turfMeta) : [];
    
                    let sahdtMeta = document.querySelector('[data-vehile-customer-metafields] [data-sahdt-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedSahdtData = sahdtMeta != '' ? JSON.parse(sahdtMeta) : [];
                    
                    localStorage.setItem('currentSelectedData', JSON.stringify(sahdtData))
                    localStorage.setItem('currentSelectedDataLabels', JSON.stringify(sahdtData))
    
                    if(partsNumber != undefined){
                        window.location.href=`/collections/all?filter.p.tag=${partsNumber}`;
                    }
                    else{
                        window.location.href=`/collections/semis-heavy-duty-trucks`;
                    }
    
                },2000);
                
            } else {
                localStorage.setItem('vehicle_data', JSON.stringify(this.selectedYMMData))
                localStorage.setItem('heavy_equipment_data', JSON.stringify(this.selectedHeavyEqipData))    
                localStorage.setItem('turf_data', JSON.stringify(this.selectedTrufData))    
                localStorage.setItem('vehicle_data_sahdt', JSON.stringify(this.selectedSahdtData))  
                localStorage.setItem('vehicle_data_side', JSON.stringify(this.selectedSideYMMData))    
    
                localStorage.setItem('currentSelectedData', JSON.stringify(sahdtData))
                localStorage.setItem('currentSelectedDataLabels', JSON.stringify(sahdtData))
    
                if(partsNumber != undefined){
                    window.location.href=`/collections/all?filter.p.tag=${partsNumber}`;
                }
                else{
                    window.location.href=`/collections/semis-heavy-duty-trucks`;
                }
            }
        }
    
    }

    _updateDefault(_this){
        let isCustomer = document.body.classList.contains('customer-loggedin');
        let idToUpdate = _this.closest('[data-vehicle-id]').getAttribute('data-vehicle-id');
        const isYMMVehicle = this.selectedYMMData.some(vehicle => vehicle.id == idToUpdate);
        const isturfVehicle = this.selectedTrufData.some( vehicle => vehicle.id == idToUpdate);
        const isSahdtVehicle = this.selectedSahdtData.some( vehicle => vehicle.id == idToUpdate );
        const isHeavyVehicle = this.selectedHeavyEqipData.some( vehicle => vehicle.id == idToUpdate );
        const isSSVehicle = this.selectedSideYMMData.some( vehicle => vehicle.id == idToUpdate );
            
        let selectedYear = "";
        let selectedMake = "";
        let selectedModel = "";
        let selectedTrim = "";
        let selectedCab = "";
        let selectedEqipType = "";
        let selectedEqipManufacturer = "";
        let selectedEqipModel = "";
        let selectedTurfType = "";
        let selectedTurfManufacturer = "";
        let selectedTurfModel = "";
        let turfJson = null;
        let selectedYearData = {
            "id": "",
            "year":"",
            "make":"",
            "model":"",
            "trim":"",
            "cabType":""
        }

        let selectedSSYearData = {
            "id": "",
            "year":"",
            "make":"",
            "model":""
        }

        let selectedEquipData = {
            "id": "",
            "equipment_category":"",
            "equipment_manufacturer":"",
            "equipment_model_number":""
        }

        let selectedTurfData = {
            "id": "",
            "equipment_category":"",
            "equipment_manufacturer":"",
            "equipment_model_number":""
        }

        let sahdtData = {
            "id": "",
            "year":"",
            "make":"",
            "model":""
        }

        // uncheck all other vehicle types
        this.selectedYMMData.forEach(vehicle => vehicle.default = false);
        this.selectedHeavyEqipData.forEach(vehicle => vehicle.default = false);
        this.selectedTrufData.forEach(vehicle => vehicle.default = false);
        this.selectedSideYMMData.forEach(vehicle => vehicle.default = false);
        this.selectedSahdtData.forEach(vehicle => vehicle.default = false);

        if(isYMMVehicle){
            
            for (let i = 0; i <  this.selectedYMMData.length; i++) {
                
                if (this.selectedYMMData[i].id == idToUpdate && _this.checked) {
                    selectedYear = this.selectedYMMData[i].year;
                    selectedMake = this.selectedYMMData[i].make;
                    selectedModel = this.selectedYMMData[i].model;
                    selectedTrim = this.selectedYMMData[i].trim;
                    selectedCab = this.selectedYMMData[i].cabType;
                    this.selectedYMMData[i].default = true;

                    selectedYearData.id = this.selectedYMMData[i].id;
                    selectedYearData.year = selectedYear;
                    selectedYearData.make = selectedMake;
                    selectedYearData.model = selectedModel;
                    selectedYearData.trim = selectedTrim;
                    selectedYearData.cabType = selectedCab;
                }                
            }
            
            if(selectedTrim != '' && selectedCab != ''){                       
                this._updateDefaultSelection('updatebtn',selectedYearData,selectedYear, selectedMake, selectedModel, selectedTrim, selectedCab);
                //window.location.href=`/collections/all?filter.p.m.custom.product_year=${selectedYear}&filter.p.m.custom.product_make=${selectedMake}&filter.p.m.custom.product_model=${selectedModel}&filter.p.m.custom.product_trim=${selectedTrim}&filter.p.m.custom.product_cab_type=${selectedCab}&filter.p.m.fit.fabric=${this.defaultMaterial}`
            } else if (selectedTrim != '' && selectedCab == ''){
                this._updateDefaultSelection('updatebtn',selectedYearData,selectedYear, selectedMake, selectedModel, selectedTrim);
            } else {               
                this._updateDefaultSelection('updatebtn',selectedYearData,selectedYear, selectedMake, selectedModel, "", "");
                //window.location.href=`/collections/all?filter.p.m.custom.product_year=${selectedYear}&filter.p.m.custom.product_make=${selectedMake}&filter.p.m.custom.product_model=${selectedModel}`
            }

            // let isCustomer = document.body.classList.contains('customer-loggedin');
            // if(isCustomer){
            //     shopifyFormUtility._updateVehicleMeta(this.selectedYMMData,partsNumber);
            // }else{
            //     localStorage.setItem('vehicle_data', JSON.stringify(this.selectedYMMData))
            //     localStorage.setItem('heavy_equipment_data', JSON.stringify(this.selectedHeavyEqipData))    
            //     localStorage.setItem('turf_data', JSON.stringify(this.selectedTrufData))    
            //     localStorage.setItem('vehicle_data_sahdt', JSON.stringify(this.selectedSahdtData))  
            //     localStorage.setItem('vehicle_data_side', JSON.stringify(this.selectedSideYMMData))    

            //     localStorage.setItem('currentSelectedData', JSON.stringify(selectedYearData))
            //     localStorage.setItem('currentSelectedDataLabels', JSON.stringify(selectedYearData))
            // }

            localStorage.setItem('vehicle_data', JSON.stringify(this.selectedYMMData))
            localStorage.setItem('heavy_equipment_data', JSON.stringify(this.selectedHeavyEqipData))    
            localStorage.setItem('turf_data', JSON.stringify(this.selectedTrufData))    
            localStorage.setItem('vehicle_data_sahdt', JSON.stringify(this.selectedSahdtData))  
            localStorage.setItem('vehicle_data_side', JSON.stringify(this.selectedSideYMMData))    

            localStorage.setItem('currentSelectedData', JSON.stringify(selectedYearData))
            localStorage.setItem('currentSelectedDataLabels', JSON.stringify(selectedYearData)) 

        } else if(isHeavyVehicle && !isSahdtVehicle) {
            for (let i = 0; i <  this.selectedHeavyEqipData.length; i++) {
                if (this.selectedHeavyEqipData[i].id == idToUpdate && _this.checked) {
                    selectedEqipType = this.selectedHeavyEqipData[i].equipment_category;
                    selectedEqipManufacturer = this.selectedHeavyEqipData[i].equipment_manufacturer;
                    selectedEqipModel = this.selectedHeavyEqipData[i].equipment_model_number;

                    selectedEquipData.id = this.selectedHeavyEqipData[i].id;
                    selectedEquipData.equipment_category = selectedEqipType;
                    selectedEquipData.equipment_manufacturer = selectedEqipManufacturer;
                    selectedEquipData.equipment_model_number = selectedEqipModel;

                    this.selectedHeavyEqipData[i].default = true;
                }
            }

            let filteredParts;
            filteredParts = [
                ...new Set(
                    Object.values(window.globalVariables.heavyvehicleJson)
                        .filter(
                            (item) =>
                                item.equipment_manufacturer == selectedEqipManufacturer &&
                                item.equipment_category == selectedEqipType &&
                                item.equipment_model_number == selectedEqipModel
                        )
                        .map((item) => item.equipment_part_number)
                ),
            ];

            var prefixedParts = filteredParts.map(function(element) {
                return "sku-" + element;
            });
            var partsNumber = prefixedParts.join(",");


            if(isCustomer){
                //shopifyFormUtility._shopifyHEFormSubmit(this.selectedHeavyEqipData,partsNumber);
                // shopifyFormUtility._updateCustomerHEMeta(this.selectedHeavyEqipData,partsNumber);
                shopifyFormUtility.allVehicleUpdate(this.selectedYMMData,this.selectedHeavyEqipData,this.selectedTrufData,this.selectedSideYMMData,this.selectedSahdtData,partsNumber);

                setTimeout(() => {
                    let vehicleMeta = document.querySelector('[data-vehile-customer-metafields] [data-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedYMMData = vehicleMeta != '' ? JSON.parse(vehicleMeta) : [];
                  
                    let heavyMeta = document.querySelector('[data-vehile-customer-metafields] [data-hevay-equp-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedHeavyEqipData = heavyMeta != '' ? JSON.parse(heavyMeta) : [];

                    let sideMeta = document.querySelector('[data-vehile-customer-metafields] [data-side-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedSideYMMData = sideMeta != '' ? JSON.parse(sideMeta) : [];

                    let turfMeta = document.querySelector('[data-vehile-customer-metafields] [data-turf-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedTrufData = turfMeta != '' ? JSON.parse(turfMeta) : [];

                    let sahdtMeta = document.querySelector('[data-vehile-customer-metafields] [data-sahdt-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedSahdtData = sahdtMeta != '' ? JSON.parse(sahdtMeta) : [];

                    localStorage.setItem('currentSelectedData', JSON.stringify(selectedEquipData))
                    localStorage.setItem('currentSelectedDataLabels', JSON.stringify(selectedYearData))

                    if(partsNumber != undefined){
                        window.location.href=`/collections/all?filter.p.tag=${partsNumber}`;
                    }
                    else{
                        window.location.href=`/collections/all`;
                    }

                },2000);
                
            } else {
                localStorage.setItem('vehicle_data', JSON.stringify(this.selectedYMMData))
                localStorage.setItem('heavy_equipment_data', JSON.stringify(this.selectedHeavyEqipData))    
                localStorage.setItem('turf_data', JSON.stringify(this.selectedTrufData))    
                localStorage.setItem('vehicle_data_sahdt', JSON.stringify(this.selectedSahdtData))  
                localStorage.setItem('vehicle_data_side', JSON.stringify(this.selectedSideYMMData))    

                localStorage.setItem('currentSelectedData', JSON.stringify(selectedEquipData))
                localStorage.setItem('currentSelectedDataLabels', JSON.stringify(selectedEquipData))

                if(partsNumber != undefined){
                    window.location.href=`/collections/all?filter.p.tag=${partsNumber}`;
                }
                else{
                    window.location.href=`/collections/all`;
                }

            }
        } else if(isturfVehicle){
            for (let i = 0; i <  this.selectedTrufData.length; i++) {
                if (this.selectedTrufData[i].id == idToUpdate && _this.checked) {
                    selectedTurfType = this.selectedTrufData[i].equipment_category;
                    selectedTurfManufacturer = this.selectedTrufData[i].equipment_manufacturer;
                    selectedTurfModel = this.selectedTrufData[i].equipment_model_number;
                    this.selectedTrufData[i].default = true;

                    selectedTurfData.id = this.selectedTrufData[i].id;
                    selectedTurfData.equipment_category = selectedTurfType;
                    selectedTurfData.equipment_manufacturer = selectedTurfManufacturer;
                    selectedTurfData.equipment_model_number = selectedTurfModel;

                } else if(this.selectedTrufData[i].id == idToUpdate) {
                  turfJson = this.selectedTrufData[i];
                }
            }

            let filteredParts;
            filteredParts = [
                ...new Set(
                    Object.values(window.globalVariables.agriTurfVehicleJson)
                        .filter(
                            (item) =>
                                item.equipment_manufacturer == selectedTurfManufacturer &&
                                item.equipment_category == selectedTurfType &&
                                item.equipment_model_number == selectedTurfModel
                        )
                        .map((item) => item.equipment_part_number)
                ),
            ];

            var prefixedParts = filteredParts.map(function(element) {
                return "sku-" + element;
            });
            var partsNumber = prefixedParts.join(",");
            if(isCustomer){
                 //shopifyFormUtility._shopifyTurfFormSubmit(this.selectedTrufData, partsNumber);
                //  shopifyFormUtility._updateCustomerTurfMeta(this.selectedTrufData, partsNumber);
                shopifyFormUtility.allVehicleUpdate(this.selectedYMMData,this.selectedHeavyEqipData,this.selectedTrufData,this.selectedSideYMMData,this.selectedSahdtData,partsNumber);

                setTimeout(() => {
                    let vehicleMeta = document.querySelector('[data-vehile-customer-metafields] [data-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedYMMData = vehicleMeta != '' ? JSON.parse(vehicleMeta) : [];
                  
                    let heavyMeta = document.querySelector('[data-vehile-customer-metafields] [data-hevay-equp-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedHeavyEqipData = heavyMeta != '' ? JSON.parse(heavyMeta) : [];

                    let sideMeta = document.querySelector('[data-vehile-customer-metafields] [data-side-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedSideYMMData = sideMeta != '' ? JSON.parse(sideMeta) : [];

                    let turfMeta = document.querySelector('[data-vehile-customer-metafields] [data-turf-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedTrufData = turfMeta != '' ? JSON.parse(turfMeta) : [];
                    
                    let sahdtMeta = document.querySelector('[data-vehile-customer-metafields] [data-sahdt-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedSahdtData = sahdtMeta != '' ? JSON.parse(sahdtMeta) : [];
                    
                    localStorage.setItem('currentSelectedData', JSON.stringify(selectedTurfData))
                    localStorage.setItem('currentSelectedDataLabels', JSON.stringify(selectedTurfData))

                    if(partsNumber != undefined){
                        window.location.href=`/collections/all?filter.p.tag=${partsNumber}`;
                    }
                    else{
                        window.location.href=`/collections/agriculture-turf-covers`;
                    }

                },2000);
                
            } else {
                localStorage.setItem('vehicle_data', JSON.stringify(this.selectedYMMData))
                localStorage.setItem('heavy_equipment_data', JSON.stringify(this.selectedHeavyEqipData))    
                localStorage.setItem('turf_data', JSON.stringify(this.selectedTrufData))    
                localStorage.setItem('vehicle_data_sahdt', JSON.stringify(this.selectedSahdtData))  
                localStorage.setItem('vehicle_data_side', JSON.stringify(this.selectedSideYMMData))    
                
                localStorage.setItem('currentSelectedData', JSON.stringify(selectedTurfData))
                localStorage.setItem('currentSelectedDataLabels', JSON.stringify(selectedTurfData))

                if(partsNumber != undefined){
                    window.location.href=`/collections/all?filter.p.tag=${partsNumber}`;
                }
                else{
                    window.location.href=`/collections/agriculture-turf-covers`;
                }
            }
        } else if(isSSVehicle){
            for (let i = 0; i <  this.selectedSideYMMData.length; i++) {
                if (this.selectedSideYMMData[i].id == idToUpdate && _this.checked) {
                    selectedYear = this.selectedSideYMMData[i].year;
                    selectedMake = this.selectedSideYMMData[i].make;
                    selectedModel = this.selectedSideYMMData[i].model;
                    this.selectedSideYMMData[i].default = true;

                    selectedSSYearData.id = this.selectedSideYMMData[i].id;
                    selectedSSYearData.year = selectedYear;
                    selectedSSYearData.make = selectedMake;
                    selectedSSYearData.model = selectedModel;
                }
                
            }

            let filteredParts;
            filteredParts = [
                ...new Set(
                    Object.values(window.globalVariables.sidevehicleJson)
                        .filter(
                            (item) =>
                                item.year == selectedYear &&
                                item.make == selectedMake &&
                                item.model == selectedModel
                        )
                        .map((item) => item.part_number)
                ),
            ];

            var prefixedParts = filteredParts.map(function(element) {
                return "sku-" + element;
            });
            var partsNumber = prefixedParts.join(",");
            
            if(isCustomer){
                //shopifyFormUtility._shopifySideFormSubmit(this.selectedSideYMMData,partsNumber);
                // shopifyFormUtility._updateCustomerSideMeta(this.selectedSideYMMData,partsNumber);
                shopifyFormUtility.allVehicleUpdate(this.selectedYMMData,this.selectedHeavyEqipData,this.selectedTrufData,this.selectedSideYMMData,this.selectedSahdtData,partsNumber);

               setTimeout(() => {
                   let vehicleMeta = document.querySelector('[data-vehile-customer-metafields] [data-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                   this.selectedYMMData = vehicleMeta != '' ? JSON.parse(vehicleMeta) : [];
                 
                   let heavyMeta = document.querySelector('[data-vehile-customer-metafields] [data-hevay-equp-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                   this.selectedHeavyEqipData = heavyMeta != '' ? JSON.parse(heavyMeta) : [];

                   let sideMeta = document.querySelector('[data-vehile-customer-metafields] [data-side-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                   this.selectedSideYMMData = sideMeta != '' ? JSON.parse(sideMeta) : [];

                   let turfMeta = document.querySelector('[data-vehile-customer-metafields] [data-turf-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                   this.selectedTrufData = turfMeta != '' ? JSON.parse(turfMeta) : [];
                   
                   localStorage.setItem('currentSelectedDataLabels', JSON.stringify(selectedSSYearData))

                if(partsNumber != undefined){
                    window.location.href=`/collections/all?filter.p.tag=${partsNumber}`;
                }
                else{
                    window.location.href=`/collections/side-by-side-seat-covers`;
                }

               },2000);
               
           } else {
            localStorage.setItem('vehicle_data', JSON.stringify(this.selectedYMMData))
            localStorage.setItem('heavy_equipment_data', JSON.stringify(this.selectedHeavyEqipData))    
            localStorage.setItem('turf_data', JSON.stringify(this.selectedTrufData))    
            localStorage.setItem('vehicle_data_sahdt', JSON.stringify(this.selectedSahdtData))  
            localStorage.setItem('vehicle_data_side', JSON.stringify(this.selectedSideYMMData))    

            localStorage.setItem('currentSelectedData', JSON.stringify(selectedYearData))
            localStorage.setItem('currentSelectedDataLabels', JSON.stringify(selectedSSYearData))

            if(partsNumber != undefined){
                window.location.href=`/collections/all?filter.p.tag=${partsNumber}`;
            }
            else{
                window.location.href=`/collections/side-by-side-seat-covers`;
            }

           }

        } else if(isSahdtVehicle){
            for (let i = 0; i <  this.selectedSahdtData.length; i++) {
                if (this.selectedSahdtData[i].id == idToUpdate && _this.checked) {
                    sahdtData.id = this.selectedSahdtData[i].id;
                    sahdtData.year = this.selectedSahdtData[i].year;
                    sahdtData.make = this.selectedSahdtData[i].make;
                    sahdtData.model = this.selectedSahdtData[i].model;
                    
                    this.selectedSahdtData[i].default = true;

                } else if(this.selectedSahdtData[i].id == idToUpdate) {
                  turfJson = this.selectedSahdtData[i];
                }
            }


            let filteredParts;
            filteredParts = [
                ...new Set(
                    Object.values(window.globalVariables.sahdtJson)
                        .filter(
                            (item) =>
                                item.year == sahdtData.year &&
                                item.make == sahdtData.make &&
                                item.model == sahdtData.model
                        )
                        .map((item) => item.part_number)
                ),
            ];

            var prefixedParts = filteredParts.map(function(element) {
                return "sku-" + element;
            });
            var partsNumber = prefixedParts.join(",");


            if(isCustomer){
                //shopifyFormUtility._shopifySemiAndHeavyDutyFormSubmit(this.selectedSahdtData,partsNumber);
                // shopifyFormUtility._updateCustomerSHeavyMeta(this.selectedSahdtData,partsNumber);

                shopifyFormUtility.allVehicleUpdate(this.selectedYMMData,this.selectedHeavyEqipData,this.selectedTrufData,this.selectedSideYMMData,this.selectedSahdtData,partsNumber);

                setTimeout(() => {
                    let vehicleMeta = document.querySelector('[data-vehile-customer-metafields] [data-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedYMMData = vehicleMeta != '' ? JSON.parse(vehicleMeta) : [];
                  
                    let heavyMeta = document.querySelector('[data-vehile-customer-metafields] [data-hevay-equp-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedHeavyEqipData = heavyMeta != '' ? JSON.parse(heavyMeta) : [];

                    let sideMeta = document.querySelector('[data-vehile-customer-metafields] [data-side-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedSideYMMData = sideMeta != '' ? JSON.parse(sideMeta) : [];

                    let turfMeta = document.querySelector('[data-vehile-customer-metafields] [data-turf-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedTrufData = turfMeta != '' ? JSON.parse(turfMeta) : [];

                    let sahdtMeta = document.querySelector('[data-vehile-customer-metafields] [data-sahdt-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedSahdtData = sahdtMeta != '' ? JSON.parse(sahdtMeta) : [];
                    
                    localStorage.setItem('currentSelectedData', JSON.stringify(sahdtData))
                    localStorage.setItem('currentSelectedDataLabels', JSON.stringify(sahdtData))
    
                    if(partsNumber != undefined){
                        window.location.href=`/collections/all?filter.p.tag=${partsNumber}`;
                    }
                    else{
                        window.location.href=`/collections/semis-heavy-duty-trucks`;
                    }

                },2000);
                
            } else {
                localStorage.setItem('vehicle_data', JSON.stringify(this.selectedYMMData))
                localStorage.setItem('heavy_equipment_data', JSON.stringify(this.selectedHeavyEqipData))    
                localStorage.setItem('turf_data', JSON.stringify(this.selectedTrufData))    
                localStorage.setItem('vehicle_data_sahdt', JSON.stringify(this.selectedSahdtData))  
                localStorage.setItem('vehicle_data_side', JSON.stringify(this.selectedSideYMMData))    

                localStorage.setItem('currentSelectedData', JSON.stringify(sahdtData))
                localStorage.setItem('currentSelectedDataLabels', JSON.stringify(sahdtData))

                if(partsNumber != undefined){
                    window.location.href=`/collections/all?filter.p.tag=${partsNumber}`;
                }
                else{
                    window.location.href=`/collections/semis-heavy-duty-trucks`;
                }

            }
        }

        // vehicleUtility._listVehicle();
        this._listVehicleEvents();

        if(document.body.classList.contains('template-account')){
            // vehicleUtility._listAccountVehicle();
            this._listVehicleEvents();
        }
    }

    _updateDropdown(){
        // Start Make Dropdown Event
        this.makeSelectInput = document.querySelectorAll('[data-make-filter-select] input');
      
        this.makeSelectInput.forEach((makeInput) => {
            makeInput.addEventListener('change', (event) => {
                let _this = event.currentTarget;
                let datashopvehiclebtn = this.querySelectorAll('[data-shop-vehicle-btn]');
                datashopvehiclebtn.forEach(button => {
                    button.classList.add('disabled');
                });
                
                document.querySelector('[data-shop-vehicle-btn-new]')?.classList.add('disabled');
                document.querySelector('[data-pdp-edit-vehicle-btn]')?.classList.add('disabled');
                document.querySelector('[data-edit-shop-vehicle-btn]')?.classList.add('disabled');

                let currentvalue = document.querySelector('[data-make-filter-select] [name="ymm-filter-make"]:checked').value;
                let currentvalueLable =  document.querySelector('[data-make-filter-select] [name="ymm-filter-make"]:checked').getAttribute('data-label');

                let els = document.querySelectorAll('shop-vehicle');
                els.forEach(el => {
                    el.querySelector('.model-default .option_txt').innerHTML = 'Model';
                    el.querySelector('.trim-default .option_txt').innerHTML = 'Trim';
                    el.querySelector('.cab-default .option_txt').innerHTML = 'Cab Type';
                    el.querySelector('[data-trim-wrap] .custom-dropdown').classList.add('disabled')
                    el.querySelector('[data-cab-wrap] .custom-dropdown').classList.add('disabled')

                    let datashopvehiclebtn = el.querySelectorAll('[data-shop-vehicle-btn]')
                    datashopvehiclebtn.forEach(button => {
                        button.classList.add('disabled');
                    });
                    
                    
                    el.trimSelect.innerHTML = '';
                    el.cabTypeSelect.innerHTML = '';
    
                    el._updateModel(currentvalueLable);
                });
            })
        });

        this.makeOptions = this.makeSelect.querySelectorAll('li');
        this.makeOptions.forEach((option) => {
            option.addEventListener('click', (event) => {
                let _this = event.currentTarget;
                this.makeOptions.forEach(option => option.classList.remove('selected'));
                _this.classList.add('selected');
                _this.closest('.custom-dropdown').querySelector('.make-default .option_txt').innerHTML = _this.querySelector('.option_txt').innerHTML;
                this.selectContainer = _this.closest('.custom--select');
                Utility.toggleElement(this.selectContainer, 'close');
            });
        }) 

        //End Make Dropdown Event


        //Start Model Dropdown Event
        this.modalSelectInput = this.modelSelect.querySelectorAll('[data-modal-filter-select] input');
        this.modalSelectInput.forEach((modelInput) => {
            modelInput.addEventListener('change', (event) => {
                let _this = event.currentTarget;
                let datashopvehiclebtn = this.querySelectorAll('[data-shop-vehicle-btn]');
                datashopvehiclebtn.forEach(button => {
                    button.classList.remove('disabled');
                })
                
                document.querySelector('[data-shop-vehicle-btn-new]')?.classList.remove('disabled');
                document.querySelector('[data-pdp-edit-vehicle-btn]')?.classList.remove('disabled');
                document.querySelector('[data-edit-shop-vehicle-btn]')?.classList.remove('disabled');

                let currentvalue = document.querySelector('[data-modal-filter-select] [name="ymm-filter-models"]:checked').value;
                let currentvalueLabel = document.querySelector('[data-modal-filter-select] [name="ymm-filter-models"]:checked').getAttribute('data-label');


                let els = document.querySelectorAll('shop-vehicle');
                els.forEach(el => {
                    el._updateTrim(currentvalueLabel);
                    el._updateRow(el.querySelector('[data-row-filter-select]'));
                    el._updateParts(el.querySelector('[data-part-filter-select]'));
                    el.querySelector('.trim-default .option_txt').innerHTML = 'Trim';
                    let datashopvehiclebtn = el.querySelectorAll('[data-shop-vehicle-btn]');
                    datashopvehiclebtn.forEach(button => {
                        button.classList.remove('disabled');
                    })
                    
                   
                });
               
                // this._updateTrim(currentvalue);
                // this._updateRow(this.rowSelect);
                // this._updateParts(this.partSelect);
            })
        });

        this.modelOptions = this.modelSelect.querySelectorAll('li');
        this.modelOptions.forEach((option) => {
            option.addEventListener('click', (event) => {
                let _this = event.currentTarget;
                this.modelOptions.forEach(option => option.classList.remove('selected'));
                _this.classList.add('selected');
                _this.closest('.custom-dropdown').querySelector('.model-default .option_txt').innerHTML = _this.querySelector('.option_txt').innerHTML;
                this.selectContainer = _this.closest('.custom--select');
                Utility.toggleElement(this.selectContainer, 'close');
            });
        }) 
        //End Model Dropdown Event

        //Start Trim Dropdown Event
        this.trimSelectInput = this.trimSelect.querySelectorAll('[data-trim-filter-select] input');
        this.trimSelectInput.forEach((trimInput) => {
            trimInput.addEventListener('change', (event) => {
                let _this = event.currentTarget;
                let currentvalue = document.querySelector('[data-trim-filter-select] [name="ymm-filter-trim"]:checked').getAttribute('data-label');
                let els = document.querySelectorAll('shop-vehicle');
                els.forEach(el => {
                    el._updateCabType(currentvalue);
                    el._updateRow(el.querySelector('[data-row-filter-select]'));
                    el._updateParts(el.querySelector('[data-part-filter-select]'));
                    el.querySelector('.cab-default .option_txt').innerHTML = 'Cab Type';
                });
                // this._updateRow(this.rowSelect);
                // this._updateParts(this.partSelect);
                // this._updateCabType(currentvalue);
            })
        });

        this.trimOptions = this.trimSelect.querySelectorAll('li');
        this.trimOptions.forEach((option) => {
            option.addEventListener('click', (event) => {
                let _this = event.currentTarget;
                this.trimOptions.forEach(option => option.classList.remove('selected'));
                _this.classList.add('selected');
                _this.closest('.custom-dropdown').querySelector('.trim-default .option_txt').innerHTML = _this.querySelector('.option_txt').innerHTML;
                this.selectContainer = _this.closest('.custom--select');
                Utility.toggleElement(this.selectContainer, 'close');
            });
        }) 
        //End Trim Dropdown Event

        //Start Cab Dropdwon Event
        this.cabSelectInput = this.cabTypeSelect.querySelectorAll('[data-cab-filter-select] input');
        this.cabSelectInput.forEach((cabInput) => {
            cabInput.addEventListener('change', (event) => {
                let datashopvehiclebtn = this.querySelectorAll('[data-shop-vehicle-btn]')
                datashopvehiclebtn.forEach(button => {
                    button.classList.remove('disabled');
                })
                
                let currentvalue = document.querySelector('[data-cab-filter-select] [name="ymm-filter-cab"]:checked').value;
                let els = document.querySelectorAll('shop-vehicle');
                document.querySelector('[data-shop-vehicle-btn-new]')?.classList.remove('disabled');
                document.querySelector('[data-pdp-edit-vehicle-btn]')?.classList.remove('disabled');
                document.querySelector('[data-edit-shop-vehicle-btn]')?.classList.remove('disabled');

                els.forEach(el => {
                    let datashopvehiclebtn = el.querySelectorAll('[data-shop-vehicle-btn]')
                    datashopvehiclebtn.forEach(button => {
                        button.classList.remove('disabled');
                    });
                    
                    el._updateRow(el.querySelector('[data-row-filter-select]'));
                    el._updateParts(el.querySelector('[data-part-filter-select]'));
                });
                // this._updateRow(this.rowSelect);
                // this._updateParts(this.partSelect);
            })
        });

        this.cabOptions = this.cabTypeSelect.querySelectorAll('li');
        this.cabOptions.forEach((option) => {
            option.addEventListener('click', (event) => {
                let _this = event.currentTarget;
                this.cabOptions.forEach(option => option.classList.remove('selected'));
                _this.classList.add('selected');
                _this.closest('.custom-dropdown').querySelector('.cab-default .option_txt').innerHTML = _this.querySelector('.option_txt').innerHTML;
                this.selectContainer = _this.closest('.custom--select');
                Utility.toggleElement(this.selectContainer, 'close');
            });
        }) 
        //End Cab Dropdwon Event

    }

    _populateSelectParts(select, options, selectBoxName){
        select.innerHTML = "";
        let optionHTML = "";

        if(select.closest("modal-dialog") != null){
            options.sort().forEach((option) => {
                if (option != null) {
                this.querySelector('[data-row-wrap]').classList.add('d-none');
                let optionVal = Utility._createSlug(option)
                if(select.closest("modal-dialog") != null){
                    optionHTML += `
                    <li class="for-check" data-value="${option}">
                        <input type="radio" class="ymm-input form-check-input d-none" value="${option}" data-label="${option}" data-value="${option}" id="year-${option}-${select.closest("modal-dialog").getAttribute("id")}" name="ymm-filter-${selectBoxName}"/>
                        <label class="option_txt form-check-label w-100 text-capitalize" for="year-${option}-${select.closest("modal-dialog").getAttribute("id")}" title="Label for ${option}">${option}</label>
                    </li>`;
                }else{
                    optionHTML += `
                    <li class="for-check" data-value="${option}">
                        <input type="radio" class="ymm-input form-check-input d-none" value="${option}" data-label="${option}" data-value="${option}" id="year-${option}" name="ymm-filter-${selectBoxName}"/>
                        <label class="option_txt form-check-label w-100 text-capitalize" for="year-${option}" title="Label for ${option}">${option}</label>
                    </li>`;
                }
            
            } 
            });
        }else{
            options.sort().forEach((option) => {
                if (option != null) {
                this.querySelector('[data-row-wrap]').classList.add('d-none');
                let optionVal = Utility._createSlug(option)
                optionHTML += `
                <li class="for-check" data-value="${option}">
                    <input type="radio" class="ymm-input form-check-input d-none" value="${option}" data-label="${option}" data-value="${option}" id="year-${option}" name="ymm-filter-${selectBoxName}"/>
                    <label class="option_txt form-check-label w-100 text-capitalize" for="year-${option}" title="Label for ${option}">${option}</label>
                </li>`;
            
            } 
            });
        }
       
        select.innerHTML = optionHTML;
        this._updateDropdown();
  
   
    }

    _populateSelectRow(select, options, selectBoxName){
        select.innerHTML = "";
        let optionHTML = "";

        if(select.closest("modal-dialog") != null){
            options.sort().forEach((option) => {
            if (option !== null) {
                let optionVal = Utility._createSlug(option)
                this.querySelector('[data-row-wrap]').classList.add('d-none');
                if(select.closest("modal-dialog") != null){
                    optionHTML += `
                    <li class="for-check" data-value="${option}">
                        <input type="radio" class="ymm-input form-check-input d-none" value="${option}" data-label="${option}" data-value="${option}" id="year-${option}-${select.closest("modal-dialog").getAttribute("id")}" name="ymm-filter-${selectBoxName}"/>
                        <label class="option_txt form-check-label w-100 text-capitalize" for="year-${option}-${select.closest("modal-dialog").getAttribute("id")}" title="Label for ${option}">${option}</label>
                    </li>`;
                }else{
                    optionHTML += `
                    <li class="for-check" data-value="${option}">
                        <input type="radio" class="ymm-input form-check-input d-none" value="${option}" data-label="${option}" data-value="${option}" id="year-${option}" name="ymm-filter-${selectBoxName}"/>
                        <label class="option_txt form-check-label w-100 text-capitalize" for="year-${option}" title="Label for ${option}">${option}</label>
                    </li>`;
                }
            } 
            });
        }else{
            options.sort().forEach((option) => {
            if (option !== null) {
                let optionVal = Utility._createSlug(option)
                this.querySelector('[data-row-wrap]').classList.add('d-none');
                optionHTML += `
                <li class="for-check" data-value="${option}">
                    <input type="radio" class="ymm-input form-check-input d-none" value="${option}" data-label="${option}" data-value="${option}" id="year-${option}" name="ymm-filter-${selectBoxName}"/>
                    <label class="option_txt form-check-label w-100 text-capitalize" for="year-${option}" title="Label for ${option}">${option}</label>
                </li>`;
            } 
            });
        }
       
        select.innerHTML = optionHTML;
        this._updateDropdown();
  
   
    }

    _populateSelect(select, options, selectBoxName){

        select.innerHTML = "";
        let optionHTML = "";

        if(selectBoxName == 'cab'){
            options.sort().forEach((option) => {
                if (option != null) {
                 
                  this.querySelector('[data-cab-wrap]').classList.remove('d-none');
                  let optionVal = Utility._createSlug(option);
  
                  if(select.closest("modal-dialog") != null){
                    optionHTML += `
                    <li class="for-check" data-value="${option}">
                        <input type="radio" class="ymm-input form-check-input d-none" value="${option}" data-label="${option}" data-value="${option}" id="year-${option}-${select.closest("modal-dialog").getAttribute("id")}" name="ymm-filter-${selectBoxName}"/>
                        <label class="option_txt form-check-label w-100 text-capitalize" for="year-${option}-${select.closest("modal-dialog").getAttribute("id")}" title="Label for ${option}">${option}</label>
                    </li>`;
                  }else{
                    optionHTML += `
                    <li class="for-check" data-value="${option}">
                        <input type="radio" class="ymm-input form-check-input d-none" value="${option}" data-label="${option}" data-value="${option}" id="year-${option}" name="ymm-filter-${selectBoxName}"/>
                        <label class="option_txt form-check-label w-100 text-capitalize" for="year-${option}" title="Label for ${option}">${option}</label>
                    </li>`;
                  }
                  
                  select.removeAttribute('disabled','disabled');
                  select.closest('.custom-dropdown').classList.remove('disabled')
                } else {
                  this.cabTypeSelect.innerHTML = "";
                  this.rowSelect.innerHTML = "";
                  this.querySelector('.cab-default .option_txt').innerHTML = 'Cab Type';
                  select.setAttribute('disabled','disabled');
                  select.closest('.custom-dropdown').classList.add('disabled')
                  //this.querySelector('[data-cab-wrap]').classList.add('d-none');
                }
            });
        } else {
            options.sort().forEach((option) => {
                if (option != null) {
                  if(selectBoxName == 'trim' || selectBoxName == 'cab'){
                      this.querySelector('[data-trim-wrap]').classList.remove('d-none');
                      this.querySelector('[data-cab-wrap]').classList.remove('d-none');
                  } else {
                      this.querySelector('[data-trim-wrap]').classList.add('d-none');
                      this.querySelector('[data-cab-wrap]').classList.add('d-none');
                  }
                  let optionVal = Utility._createSlug(option);
                  if(select.closest("modal-dialog") != null){
                    optionHTML += `
                    <li class="for-check" data-value="${option}">
                        <input type="radio" class="ymm-input form-check-input d-none" value="${option}" data-label="${option}" data-value="${option}" id="year-${option}-${select.closest("modal-dialog").getAttribute("id")}" name="ymm-filter-${selectBoxName}"/>
                        <label class="option_txt form-check-label w-100 text-capitalize" for="year-${option}-${select.closest("modal-dialog").getAttribute("id")}" title="Label for ${option}">${option}</label>
                    </li>`;
                  }else{
                    optionHTML += `
                    <li class="for-check" data-value="${option}">
                        <input type="radio" class="ymm-input form-check-input d-none" value="${option}" data-label="${option}" data-value="${option}" id="year-${option}" name="ymm-filter-${selectBoxName}"/>
                        <label class="option_txt form-check-label w-100 text-capitalize" for="year-${option}" title="Label for ${option}">${option}</label>
                    </li>`;
                  }
                  
                  select.removeAttribute('disabled','disabled');
                  select.closest('.custom-dropdown').classList.remove('disabled')
                } else {
                  this.trimSelect.innerHTML = "";
                  this.cabTypeSelect.innerHTML = "";
                  this.rowSelect.innerHTML = "";
                  this.querySelector('.trim-default .option_txt').innerHTML = 'Trim';
                  this.querySelector('.cab-default .option_txt').innerHTML = 'Cab Type';
                  // select.setAttribute('disabled','disabled');
                  // select.closest('.custom-dropdown').classList.add('disabled')
                  // this.querySelector('[data-trim-wrap]').classList.add('d-none');
                  // this.querySelector('[data-cab-wrap]').classList.add('d-none');
                }
            });
        }
    
        select.innerHTML = optionHTML;
        this._updateDropdown();
      
       
    }
    _updateMakes(inputValue){
        const selectedYear = inputValue;
        // Filter available options based on user selections
        const filteredMakes = this.uniqueYears.includes(selectedYear)
            ? [
                ...new Set(
                Object.values(this.vehicleJsonData)
                    .filter((item) => item.year === selectedYear)
                    .map((item) => item.make)
                ),
            ]
            : this.uniqueYears;
       

        // Populate the selects with filtered options
        this._populateSelect(this.makeSelect, filteredMakes, 'make');
    }
    _updateModel() {
        let selectedYear = document.querySelector('[data-year-filter-select] [name="year-filter"]:checked').getAttribute('data-label');
        let selectedMake = document.querySelector('[data-make-filter-select] [name="ymm-filter-make"]:checked').getAttribute('data-label');
      
        const filteredModels =
          selectedMake !== ""
            ? [
                ...new Set(
                  Object.values(this.vehicleJsonData)
                    .filter(
                      (item) =>
                        item.year === selectedYear && item.make === selectedMake
                    )
                    .map((item) => item.model)
                ),
              ]
            : this.uniqueModels;

       
        this._populateSelect(this.modelSelect, filteredModels, 'models');
    }
    
    _updateTrim() {
        let selectedYear = document.querySelector('[data-year-filter-select] [name="year-filter"]:checked').getAttribute('data-label');
        let selectedMake = document.querySelector('[data-make-filter-select] [name="ymm-filter-make"]:checked').getAttribute('data-label');
        let selectedModel = document.querySelector('[data-modal-filter-select] [name="ymm-filter-models"]:checked').getAttribute('data-label');

        const filteredTrims =
          selectedModel !== ""
            ? [
                ...new Set(
                  Object.values(this.vehicleJsonData)
                    .filter(
                      (item) =>
                        item.year === selectedYear &&
                        item.make === selectedMake &&
                        item.model === selectedModel
                    )
                    .map((item) => item.trim)
                ),
              ]
            : this.uniqueTrims;
       
        this._populateSelect(this.trimSelect, filteredTrims, 'trim');
    }

    _updateCabType() {
        let selectedYear = document.querySelector('[data-year-filter-select] [name="year-filter"]:checked').getAttribute('data-label');
        let selectedMake = document.querySelector('[data-make-filter-select] [name="ymm-filter-make"]:checked').getAttribute('data-label');
        let selectedModel = document.querySelector('[data-modal-filter-select] [name="ymm-filter-models"]:checked').getAttribute('data-label');
        let selectedTrim = document.querySelector('[data-trim-filter-select] [name="ymm-filter-trim"]:checked').getAttribute('data-label');

        const filteredCabTypes =
          selectedTrim !== ""
            ? [
                ...new Set(
                  Object.values(this.vehicleJsonData)
                    .filter(
                      (item) =>
                        item.year === selectedYear &&
                        item.make === selectedMake &&
                        item.model === selectedModel &&
                        item.trim === selectedTrim
                    )
                    .map((item) => item.cab_type)
                ),
              ]
            : this.uniqueCabTypes;
       
      
        this._populateSelect(this.cabTypeSelect, filteredCabTypes, 'cab');
    }

    _updateRow(rowSelect) {
        let selectedYear = document.querySelector('[data-year-filter-select] [name="year-filter"]:checked').value;
        let selectedMake = document.querySelector('[data-make-filter-select] [name="ymm-filter-make"]:checked').value;
        let selectedModel = document.querySelector('[data-modal-filter-select] [name="ymm-filter-models"]:checked').value;;
      
        let selectedTrimEle = this.querySelector('[data-trim-filter-select] [name="ymm-filter-trim"]:checked');
        let selectedTrim = selectedTrimEle ? selectedTrimEle.value : "" ;
        let selectedCabEle = this.querySelector('[data-cab-filter-select] [name="ymm-filter-cab"]:checked');
        let selectedCabType = selectedCabEle ? selectedCabEle.value : "" ;
        let filteredRows;
        if(selectedTrim == '' && selectedCabType == ''){
            filteredRows =
                selectedModel !== ""
                ? [
                    ...new Set(
                        Object.values(this.vehicleJsonData)
                        .filter(
                            (item) =>
                            item.year === selectedYear &&
                            item.make === selectedMake &&
                            item.model === selectedModel 
                        )
                        .map((item) => item.row)
                    ),
                    ]
                : this.uniqueRows;
        } else if(selectedTrim != '' && selectedCabType == ''){
            filteredRows =
            selectedModel !== ""
            ? [
                ...new Set(
                    Object.values(this.vehicleJsonData)
                    .filter(
                        (item) =>
                        item.year === selectedYear &&
                        item.make === selectedMake &&
                        item.model === selectedModel &&
                        item.trim === selectedTrim
                    )
                    .map((item) => item.row)
                ),
                ]
            : this.uniqueRows;
        } else {
            filteredRows =
                selectedCabType !== ""
                ? [
                    ...new Set(
                        Object.values(this.vehicleJsonData)
                        .filter(
                            (item) =>
                            item.year === selectedYear &&
                            item.make === selectedMake &&
                            item.model === selectedModel &&
                            item.trim === selectedTrim &&
                            item.cab_type === selectedCabType
                        )
                        .map((item) => item.row)
                    ),
                    ]
                : this.uniqueRows;
        }

        this._populateSelectRow(rowSelect, filteredRows, 'row');
    }

    _updateParts(partSelect){
        let selectedYear = document.querySelector('[data-year-filter-select] [name="year-filter"]:checked').getAttribute('data-label');
        let selectedMake = document.querySelector('[data-make-filter-select] [name="ymm-filter-make"]:checked').getAttribute('data-label');
        let selectedModel = document.querySelector('[data-modal-filter-select] [name="ymm-filter-models"]:checked').getAttribute('data-label');
      
        let selectedTrimEle = this.querySelector('[data-trim-filter-select] [name="ymm-filter-trim"]:checked');
        let selectedTrim = selectedTrimEle ? selectedTrimEle.getAttribute('data-label') : "" ;
        let selectedCabEle = this.querySelector('[data-cab-filter-select] [name="ymm-filter-cab"]:checked');
        let selectedCabType = selectedCabEle ? selectedCabEle.getAttribute('data-label') : "" ;
        let rowEls = this.querySelectorAll('[data-row-filter-select] li');
        let uniquePartNumbers = [];

        if (rowEls.length > 0) {
            rowEls.forEach((row) => {
                let rowValue = row.getAttribute('data-value');
                let filteredParts;

                if (selectedTrim == '' && selectedCabType == '') {
                    filteredParts = [
                        ...new Set(
                            Object.values(this.vehicleJsonData)
                                .filter(
                                    (item) =>
                                        item.year === selectedYear &&
                                        item.make === selectedMake &&
                                        item.model === selectedModel &&
                                        item.row === rowValue
                                )
                                .map((item) => item.part_number)
                        ),
                    ];
                } else if(selectedTrim != '' && selectedCabType == ''){
                    filteredParts = [
                        ...new Set(
                            Object.values(this.vehicleJsonData)
                                .filter(
                                    (item) =>
                                        item.year === selectedYear &&
                                        item.make === selectedMake &&
                                        item.model === selectedModel &&
                                        item.trim === selectedTrim &&
                                        item.row === rowValue
                                )
                                .map((item) => item.part_number)
                        ),
                    ];
                } else {
                    filteredParts = [
                        ...new Set(
                            Object.values(this.vehicleJsonData)
                                .filter(
                                    (item) =>
                                        item.year === selectedYear &&
                                        item.make === selectedMake &&
                                        item.model === selectedModel &&
                                        item.trim === selectedTrim &&
                                        item.cab_type === selectedCabType &&
                                        item.row === rowValue
                                )
                                .map((item) => item.part_number)
                        ),
                    ];
                }

                // Add the unique part numbers to the result array
                uniquePartNumbers.push(...filteredParts);
            });
        }
        else{
           
            let filteredParts;
      
            if (selectedTrim == '' && selectedCabType == '') {
              filteredParts = [
                  ...new Set(
                      Object.values(this.vehicleJsonData)
                          .filter(
                              (item) =>
                                  item.year === selectedYear &&
                                  item.make === selectedMake &&
                                  item.model === selectedModel 
                          )
                          .map((item) => item.part_number)
                  ),
              ];
            }  else if(selectedTrim != '' && selectedCabType == ''){
                filteredParts = [
                    ...new Set(
                        Object.values(this.vehicleJsonData)
                            .filter(
                                (item) =>
                                    item.year === selectedYear &&
                                    item.make === selectedMake &&
                                    item.model === selectedModel &&
                                    item.trim === selectedTrim 
                            )
                            .map((item) => item.part_number)
                    ),
                ];
            } else {
                filteredParts = [
                  ...new Set(
                      Object.values(this.vehicleJsonData)
                          .filter(
                              (item) =>
                                  item.year === selectedYear &&
                                  item.make === selectedMake &&
                                  item.model === selectedModel &&
                                  item.trim === selectedTrim &&
                                  item.cab_type === selectedCabType 
                          )
                          .map((item) => item.part_number)
                  ),
              ];
          }
      
          // Add the unique part numbers to the result array
          uniquePartNumbers.push(...filteredParts);
          }

        // Remove duplicates from the result array
        uniquePartNumbers = [...new Set(uniquePartNumbers)];
        this.selectedPartNumber = uniquePartNumbers;
        localStorage.setItem('partNumbers', JSON.stringify(uniquePartNumbers));

        this._populateSelectParts(partSelect, uniquePartNumbers, 'part');
    }

    _updateDefaultSelection(event,selectedYearData,selectedYear, selectedMake, selectedModel, selectedTrim, selectedCabType) {

        let filteredRows;
        let uniquePartNumbers = [];
    
        // Normalize input values
        const safeSelectedYear = (selectedYear || "").toLowerCase();
        const safeSelectedMake = (selectedMake || "").toLowerCase();
        const safeSelectedModel = (selectedModel || "").toLowerCase();
        const safeSelectedTrim = (selectedTrim || "").toLowerCase();
        const safeSelectedCabType = (selectedCabType || "").toLowerCase();
    
        // Filter rows based on the selected criteria
        if (safeSelectedTrim === '' && safeSelectedCabType === '') {
            // Handle the case where no trim and cab type are selected
            if (safeSelectedModel.trim() !== "") {
                filteredRows = [...new Set(
                    Object.values(this.vehicleJsonData)
                        .filter(item => {
                            // Normalize item properties to lowercase for case-insensitive comparison
                            return (item.year || "").toLowerCase() === safeSelectedYear &&
                                   (item.make || "").toLowerCase() === safeSelectedMake &&
                                   (item.model || "").toLowerCase() === safeSelectedModel;
                        })
                        .map(item => item.row)
                )];
            } else {
                filteredRows = this.uniqueRows;
            }
        } else if (safeSelectedTrim !== '' && safeSelectedCabType === undefined) {
            // Handle the case where trim is selected but cab type is not defined
            if (safeSelectedTrim.trim()) {
                filteredRows = [...new Set(
                    Object.values(this.vehicleJsonData)
                        .filter(item => {
                            return (item.year || "").toLowerCase() === safeSelectedYear &&
                                   (item.make || "").toLowerCase() === safeSelectedMake &&
                                   (item.model || "").toLowerCase() === safeSelectedModel &&
                                   (item.trim || "").toLowerCase() === safeSelectedTrim;
                        })
                        .map(item => item.row)
                )];
            } else {
                filteredRows = this.uniqueRows;
            }
        } else {
            // Handle the case where both trim and cab type are selected
            if (safeSelectedCabType.trim()) {
                filteredRows = [...new Set(
                    Object.values(this.vehicleJsonData)
                        .filter(item => {
                            return (item.year || "").toLowerCase() === safeSelectedYear &&
                                   (item.make || "").toLowerCase() === safeSelectedMake &&
                                   (item.model || "").toLowerCase() === safeSelectedModel &&
                                   (item.trim || "").toLowerCase() === safeSelectedTrim &&
                                   (item.cab_type || "").toLowerCase() === safeSelectedCabType;
                        })
                        .map(item => item.row)
                )];
            } else {
                filteredRows = this.uniqueRows;
            }
        }
    
    
        // Process each filtered row to get unique part numbers
        filteredRows.forEach(row => {
            let filteredParts;
    
            if (safeSelectedTrim === '' && safeSelectedCabType === '') {
                filteredParts = [...new Set(
                    Object.values(this.vehicleJsonData)
                        .filter(item =>
                            (item.year || "").toLowerCase() === safeSelectedYear &&
                            (item.make || "").toLowerCase() === safeSelectedMake &&
                            (item.model || "").toLowerCase() === safeSelectedModel &&
                            item.row === row
                        )
                        .map(item => item.part_number)
                )];
            } else if (safeSelectedTrim !== '' && safeSelectedCabType === undefined) {
                filteredParts = [...new Set(
                    Object.values(this.vehicleJsonData)
                        .filter(item =>
                            (item.year || "").toLowerCase() === safeSelectedYear &&
                            (item.make || "").toLowerCase() === safeSelectedMake &&
                            (item.model || "").toLowerCase() === safeSelectedModel &&
                            (item.trim || "").toLowerCase() === safeSelectedTrim &&
                            item.row === row
                        )
                        .map(item => item.part_number)
                )];
            } else {
                filteredParts = [...new Set(
                    Object.values(this.vehicleJsonData)
                        .filter(item =>
                            (item.year || "").toLowerCase() === safeSelectedYear &&
                            (item.make || "").toLowerCase() === safeSelectedMake &&
                            (item.model || "").toLowerCase() === safeSelectedModel &&
                            (item.trim || "").toLowerCase() === safeSelectedTrim &&
                            (item.cab_type || "").toLowerCase() === safeSelectedCabType &&
                            item.row === row
                        )
                        .map(item => item.part_number)
                )];
            }
        
            // Add the unique part numbers to the result array
            uniquePartNumbers.push(...filteredParts);
        });
    
        // Store unique part numbers in localStorage
        localStorage.setItem('partNumbers', JSON.stringify(uniquePartNumbers));
    
        // Prefix part numbers and create a comma-separated string
        const prefixedParts = uniquePartNumbers.map(element => `sku-${element}`);
        const partsNumber = prefixedParts.join(",");

        let isCustomer = document.body.classList.contains('customer-loggedin');

        if(isCustomer){
            //shopifyFormUtility._shopifyVehicleFormSubmit(this.selectedYMMData,partsNumber);
            if(event == 'updatebtn')
                shopifyFormUtility.allVehicleUpdate(this.selectedYMMData,this.selectedHeavyEqipData,this.selectedTrufData,this.selectedSideYMMData,this.selectedSahdtData,partsNumber);
                // shopifyFormUtility._updateVehicleMeta(this.selectedYMMData,partsNumber);
            
                let vehicleMeta = document.querySelector('[data-vehile-customer-metafields] [data-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                this.selectedYMMData = vehicleMeta != '' ? JSON.parse(vehicleMeta) : [];
              
                let heavyMeta = document.querySelector('[data-vehile-customer-metafields] [data-hevay-equp-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                this.selectedHeavyEqipData = heavyMeta != '' ? JSON.parse(heavyMeta) : [];

                let sideMeta = document.querySelector('[data-vehile-customer-metafields] [data-side-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                this.selectedSideYMMData = sideMeta != '' ? JSON.parse(sideMeta) : [];

                let turfMeta = document.querySelector('[data-vehile-customer-metafields] [data-turf-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                this.selectedTrufData = turfMeta != '' ? JSON.parse(turfMeta) : [];

                let sahdtMeta = document.querySelector('[data-vehile-customer-metafields] [data-sahdt-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                this.selectedSahdtData = sahdtMeta != '' ? JSON.parse(sahdtMeta) : [];
                localStorage.setItem('currentSelectedData', JSON.stringify(selectedYearData))
                localStorage.setItem('currentSelectedDataLabels', JSON.stringify(selectedYearData))                            
        } else {
            localStorage.setItem('vehicle_data', JSON.stringify(this.selectedYMMData))
            localStorage.setItem('heavy_equipment_data', JSON.stringify(this.selectedHeavyEqipData))    
            localStorage.setItem('turf_data', JSON.stringify(this.selectedTrufData))    
            localStorage.setItem('vehicle_data_sahdt', JSON.stringify(this.selectedSahdtData))    
            localStorage.setItem('currentSelectedData', JSON.stringify(selectedYearData))
            localStorage.setItem('currentSelectedDataLabels', JSON.stringify(selectedYearData))
        }

        // Redirect to parts page
        setTimeout(() => {
            this._redirectToParts(partsNumber);
        },1500);
        
    }
    
}

customElements.define('shop-vehicle', ymmJS);
